export const phrases = [
    {
        en: "Good luck!",
        ru: "Удачи!",
        topic: "greeting",
        altEn: ["break a leg"],
        altRu: [],
    },
    {
        en: "Have a good weekend!",
        ru: "Хороших выходных!",
        topic: "greeting",
        altEn: ["have a nice weekend",
                "have a great weekend"],
        altRu: ["хороших тебе выходных",
                "хороших вам выходных"],
    },
    {
        en: "Have a nice day!",
        ru: "Хорошего дня!",
        topic: "greeting",
        altEn: ["have a good day",
                "have a nice one", 
                "have a good one"],
        altRu: ["хорошего тебе дня",
                "хорошего вам дня"],
    },
    {
        en: "Hope to see you again!",
        ru: "Надеюсь увидеть вас снова!",
        topic: "greeting",
        altEn: ["i hope to see you again"],
        altRu: ["надеюсь увидеть тебя снова", "надеюсь увидеться снова",
                "надеюсь снова увидеться", "надеюсь увидеть тебя вновь",
                "надеюсь увидеть вас вновь", "я надеюсь увидеть тебя снова",
                "я надеюсь увидеться снова", "я надеюсь снова увидеться",
                "я надеюсь увидеть тебя вновь", "я надеюсь увидеть вас вновь",
                "я надеюсь увидеть вас снова"],
    },
    {
        en: "How are you?",
        ru: "Как ты?",
        topic: "greeting",
        altEn: ["how are you getting on", "how are you keeping",
                "how do you do", "howre you", "howre you getting on",
                "howre you keeping"],
        altRu: ["как вы", "как поживаете", "как поживаешь"],
    },
    {
        en: "How is it going?",
        ru: "Как идут дела?",
        topic: "greeting",
        altEn: ["hows it going", "how are things going", 
                "how are things", "how is tricks", "how is everything",
                "howre things", "howre things going",
                "hows tricks", "hows everything"],
        altRu: ["как дела", "как твои дела", "как ваши дела",
                "как делишки", "как оно"],
    },
    {
        en: "How is life?",
        ru: "Как жизнь?",
        topic: "greeting",
        altEn: ["hows life"],
        altRu: ["как поживаешь", "как поживаете"],
    },
    {
        en: "How is your day?",
        ru: "Как твой день?",
        topic: "greeting",
        altEn: ["hows your day",
                "how is your day going",
                "hows your day going"],
        altRu: ["как ваш день",
                "как проходит день", "как день проходит",
                "как день", "как проходит твой день",
                "как твой день проходит",
                "как проходит ваш день",
                "как ваш день проходит"],
    },
    {
        en: "I have to run",
        ru: "Я должен бежать",
        topic: "greeting",
        altEn: ["ive to run"],
        altRu: ["мне пора бежать", "мне надо бежать", "я должна бежать"],
    },
    {
        en: "It's good to have you here! ",
        ru: "Хорошо, что ты здесь!",
        topic: "greeting",
        altEn: ["it is good to have you here", "its good that youre here",
                "it is good that youre here", "it is good that you are here", "its good that you are here"],
        altRu: ["как хорошо что ты здесь", 
                "это хорошо что ты здесь"],
    },
    {
        en: "Keep in touch!",
        ru: "Держите в курсе!",
        topic: "greeting",
        altEn: ["stay in touch", "remain in touch"],
        altRu: ["оставайтесь на связи", "не пропадайте",
                "оставайся на связи", "не пропадай", "держи в курсе",
                "держи в курсе дел", "держите в курсе дел",
                "будьте на связи", "будь на связи", 
                "держи меня в курсе", "держите меня в курсе",
                "держи нас в курсе", "держите нас в курсе",
                "держи меня в курсе дел", "держите меня в курсе дел",
                "держи нас в курсе дел", "держите нас в курсе дел"],
    },
    {
        en: "Let's talk later!",
        ru: "Давайте поговорим позже!",
        topic: "greeting",
        altEn: ["talk to you later", "i talk to you later",
                "let us talk later"],
        altRu: ["поговорим позже", "поговорим позднее",
                "давай поговорим позже", "давай поговорим позднее",
                "давайте поговорим позднее"],
    },
    {
        en: "Long time no see!",
        ru: "Давно не виделись!",
        topic: "greeting",
        altEn: ["long time no hear", "it has been a while",
                "its been a while", "long time no see you",
                "long time no hear you"],
        altRu: ["давненько не виделись", 
                "сколько лет сколько зим",
                "долго не виделись"],
    },
    {
        en: "Nice to see you!",
        ru: "Рад вас видеть!",
        topic: "greeting",
        altEn: ["it is nice to see you", "its nice to see you",
                "good to see you", "pleased to see you",
                "glad to see you", "it is good to see you",
                "i am pleased to see you", "i am glad to see you",
                "its good to see you", "im pleased to see you",
                "im glad to see you"],
        altRu: ["рад увидеть вас",
                "рад вас увидеть", "рад видеть вас", "рад тебя видеть",
                "рад тебя увидеть", "рад увидеть тебя", "рад видеть тебя",
                "рада вас видеть",
                "рада увидеть вас", "рада вас увидеть", 
                "рада видеть вас", "рада тебя видеть",
                "рада тебя увидеть", "рада увидеть тебя", 
                "рада видеть тебя"],
    },
    {
        en: "Pleased to meet you!",
        ru: "Рад знакомству!",
        topic: "greeting",
        altEn: ["nice to meet you", "glad to meet you",
                "i am pleased to meet you", "it is nice to meet you",
                "i am glad to meet you", "im pleased to meet you",
                "its nice to meet you", "im glad to meet you",
                "my pleasure"],
        altRu: ["рад встрече", "рад нашей встрече",
                "рад встрече с вами", "рад познакомиться с вами",
                "рад встретиться с вами", "рад встретить вас",
                "рад с вами познакомиться", "рад с вами встретиться",
                "рад вас встретить", "рад был встретиться",
                "рад был познакомиться", "рад был познакомиться с вами",
                "рад был встретиться с вами", "рад был встретить вас",
                "рад был с вами познакомиться", 
                "рад был с вами встретиться", "рад был вас встретить",
                "приятно познакомиться", "приятно было познакомиться",
                "рада встрече", "рада нашей встрече",
                "рада встрече с вами", "рада познакомиться с вами",
                "рада встретиться с вами", "рада встретить вас",
                "рада с вами познакомиться",  "рада с вами встретиться",
                "рада вас встретить", "рада была встретиться",
                "рада была познакомиться", "рада была познакомиться с вами",
                "рада была встретиться с вами", "рада была встретить вас",
                "рада была с вами познакомиться",  "рада была с вами встретиться",
                "рада была вас встретить", "рада знакомству"],
    },
    {
        en: "Say hi to…",
        ru: "Передавай привет…",
        topic: "greeting",
        altEn: ["give my regards to", "say hello to",
                "send my love to", "give my love to"],
        altRu: ["передай привет", "передайте привет",
                "передавайте привет"],
    },
    {
        en: "See you later!",
        ru: "Увидимся позже!",
        topic: "greeting",
        altEn: ["see you soon", "see you later alligator",
                "see you around"],
        altRu: ["до встречи", "еще увидимся", "увидимся позднее"],
    },
    {
        en: "See you soon!",
        ru: "До скорого!",
        topic: "greeting",
        altEn: ["see you", "see you around"],
        altRu: ["до скорой встречи", "до скорых встреч", 
                "скоро увидимся", "до встречи", "еще увидимся"],
    },
    {
        en: "Take care!",
        ru: "Береги себя!",
        topic: "greeting",
        altEn: ["take care of yourself"],
        altRu: ["счастливо", "берегите себя", 
                "будьте осторожны", "будь осторожен", "берегись"],
    },
    {
        en: "Time for me to go",
        ru: "Мне пора идти",
        topic: "greeting",
        altEn: ["i better head out", "i better get going",
                "i have to go", "ive to go", "its time for me to go", 
                "it is time for me to go"],
        altRu: ["мне пора идти", "мне пора уходить"],
    },
    {
        en: "Until we meet again!",
        ru: "До новой встречи!",
        topic: "greeting",
        altEn: ["goodbye for now", "good bye for now", 
                "bye for now", "goodbye until next time",
                "good bye until next time", "until next time", 
                "till next time", "till we meet again", 
                "until we meet again"],
        altRu: ["до новых встреч", "до следующей встречи",
                "до встречи"],
    },
    {
        en: "Until next time!",
        ru: "До следующего раза!",
        topic: "greeting",
        altEn: ["goodbye for now","good bye for now",
                "bye for now", "goodbye until next time",
                "good bye until next time", "until next time", 
                "till next time", "till we meet again", 
                "until we meet again"],
        altRu: ["до новых встреч", "до следующей встречи",
                "до встречи"],
    },
    {
        en: "What are you up to?",
        ru: "Чем ты будешь занят?",
        topic: "greeting",
        altEn: ["what are you doing", "what do you want to do",
                "what will you do", "what would you do",
                "whatll you do", "whatd you do"],
        altRu: ["чем занят", "чем занимаешься",
                "чем планируешь заняться", "чем планируешь заниматься",
                "чем будешь заниматься", "чем ты занимаешься",
                "чем ты планируешь заняться", "чем ты планируешь заниматься",
                "чем ты будешь заниматься", "что ты делаешь",
                "что ты задумал", "чем ты занят"],
    },
    {
        en: "What have you been up to lately?",
        ru: "Чем ты занимался в последнее время?",
        topic: "greeting",
        altEn: ["whatve you been up to lately",
                "what have you been doing lately",
                "whatve you been doing lately",
                "what have you been do lately",
                "whatve you been do lately",
                "hat have you been up to recently",
                "what have you been doing recently",
                "whatve you been doing recently",
                "what have you been do recently",
                "whatve you been do recently",
                "hat have you been up to"],
        altRu: ["что ты делал в последнее время",
                "что вы делали в последнее время",
                "чем вы занимались в последнее время",
                "чем ты был занят в последнее время",
                "чем вы были заняты в последнее время"],
    },
    {
        en: "What's new?",
        ru: "Что нового?",
        topic: "greeting",
        altEn: ["what is new", "what is the news",
                "what is going on", "whats the news",
                "whats going on", "whats up", "what is up"],
        altRu: ["какие новости",
                "что происходит"],
    },
    {
        en: "According to…",
        ru: "Согласно с…",
        topic: "intro",
        altEn: ["in accordance with"],
        altRu: ["в соответствии с", "согласно", "по словам", 
                "по мнению", "по утверждению"],
    },
    {
        en: "After all",
        ru: "В конце концов",
        topic: "intro",
        altEn: ["eventually", "in the end", "after all", "finally", 
                "ultimately", "in the long run", "at long last"],
        altRu: ["в итоге", "в конечном счете", "всетаки"],
    },
    {
        en: "All things considered",
        ru: "Учитывая все обстоятельства",
        topic: "intro",
        altEn: ["all in all", "overall", "on the whole",
        "given the circumstances","given these circumstances",
        "under the circumstances", "in the circumstances",
        "considering all the circumstances",
        "given these conditions"],
        altRu: ["приняв все во мнимание",
                "приняв все это во внимание",
                "приняв во внимание все факты", 
                "приняв во внимание все обстоятельства",
                "учитывая все факты",
                "с учетом всех обстоятельств", 
                "с учетом всех фактов",
                "принимая все во внимание",
                "принимая все это во внимание",
                "принимая во внимание все факты", 
                "принимая во внимание все обстоятельства",
                "в общем", "в общем и целом",
                "если учесть все обстоятельства",
                "если учесть все факты",
                "если учитывать все обстоятельства",
                "если учитывать все факты",
                "учитывая сложившиеся обстоятельства",
                "с учетом сложившихся обстоятельств",
                "приняв во внимание сложившиеся обстоятельства",
                "принимая во внимание сложившиеся обстоятельства",
                "если учесть сложившиеся обстоятельства",
                "если учитывать сложившиеся обстоятельства"],
    },
    {
        en: "And so on and so forth",
        ru: "И так далее",
        topic: "intro",
        altEn: ["and so on", "and so forth", "et cetera", "etcetera", "etc"],
        altRu: ["и так далее и тому подобное", 
                "и так далее и так далее", "и тому подобное",
                "и т д", "и тд", "и тд и тп", "и т д и т п", "и тп", "и т п"],
    },
    {
        en: "As a result",
        ru: "В результате",
        topic: "intro",
        altEn: ["consequently", "in the issue", "in sum",
                "in consequence"],
        altRu: ["в итоге", "как результат", "вследствие",
                "как следствие", "следственно"],
    },
    {
        en: "As a rule",
        ru: "Как правило",
        topic: "intro",
        altEn: ["in general", "as a general rule", "typically", 
                "usually", "generally", "as a matter of course",
                "generally speaking", "by and large",
                "for the most part", "for the most part",
                "in most cases", "in the main", 
                "in the usual course of things"],
        altRu: ["обычно", "в основном", "чаще всего"],
    },
    {
        en: "As far as i remember",
        ru: "Насколько я помню",
        topic: "intro",
        altEn: ["as far as i recall"],
        altRu: ["насколько я могу вспомнить", "насколько я могу помнить"],
    },
    {
        en: "As for…",
        ru: "Что касается…",
        topic: "intro",
        altEn: ["concerning", "regarding", "in reference to",
                "with regard to", "as concerns"],
        altRu: ["что до", "насчет", "что насчет"],
    },
    {
        en: "At least",
        ru: "По крайней мере",
        topic: "intro",
        altEn: ["leastways", "leastwise", "at any rate", 
                "at the least"],
        altRu: ["по меньшей мере", "во всяком случае"],
    },
    {
        en: "At the same time",
        ru: "В то же время",
        topic: "intro",
        altEn: ["nevertheless", "along with that", "nonetheless"],
        altRu: ["вместе с тем", "в то же самое время", 
                "одновременно", "тем не менее"],
    },
    {
        en: "By the way",
        ru: "Кстати",
        topic: "intro",
        altEn: ["by the by", "to the point", "by the bye", 
                "by this token"],
        altRu: ["между прочим", "кстати говоря", "к слову"],
    },
    {
        en: "First of all",
        ru: "Прежде всего",
        topic: "intro",
        altEn: ["primarily", "first of all", "foremost", 
                "in the first place", "in the first instance"],
        altRu: ["в первую очередь", "вопервых", "во первых"],
    },
    {
        en: "For instance",
        ru: "Например",
        topic: "intro",
        altEn: ["for example", "as an example"],
        altRu: ["к примеру"],
    },
    {
        en: "Fortunately",
        ru: "К счастью",
        topic: "intro",
        altEn: ["luckily", "happily", "by good luck", 
                "by a happy chance"],
        altRu: ["по счастливой случайности"],
    },
    {
        en: "Given that…",
        ru: "Учитывая, что…",
        topic: "intro",
        altEn: ["considering that", "bearing in mind that",
                "since the", "in view of the fact that"],
        altRu: ["имея в виду что", "поскольку", 
                "ввиду того что", "ввиду того факта что", 
                "с учетом того что", "с учетом того факта что", 
                "при условии что", "принимая во внимание что",
                "в силу того что", "исходя из того что", 
                "в связи с тем что", "поскольку",
                "если учитывать что", "если иметь в виду что",
                "если принять во внимание что", 
                "если принимать во внимание что",
                "если исходить из того что",
                "если учитывать тот факт что",
                "если принять во внимание тот факт что", 
                "если принимать во внимание тот факт  что",
                "если исходить из того факта что"],
    },
    {
        en: "I would like to point out that…",
        ru: "Я хотел бы отметить, что…",
        topic: "intro",
        altEn: ["id like to point out that"],
        altRu: ["я хотел бы заметить что", 
                "я хотел бы отметить", "я хотел бы заметить", 
                "я хотел бы обратить ваше внимание на", 
                "я хотел бы обратить твое внимание на",
                "я хотела бы отметить что",
                "я хотела бы заметить что", 
                "я хотела бы отметить", "я хотела бы заметить", 
                "я хотела бы обратить ваше внимание на", 
                "я хотела бы обратить твое внимание на",
                "хотелось бы отметить что",
                "хотелось бы заметить что", 
                "хотелось бы отметить", "хотелось бы заметить", 
                "хотелось бы обратить ваше внимание на", 
                "хотелось бы обратить твое внимание на"],
    },
    {
        en: "If my memory serves me well",
        ru: "Если мне не изменяет память",
        topic: "intro",
        altEn: ["if my memory serves me correctly",
                "if my memory serves me right",
                "if my memory serves me", 
                "if memory serves",
                "if i remember correctly",
                "if my memory is correct",
                "if my memorys correct"],
        altRu: ["если я правильно помню",
                "если память мне не изменяет",
                "если моя память мне не изменяет",
                "если моя память не изменяет мне",
                "если память не изменяет мне",
                "если мне не изменяет моя память",
                "если я помню правильно"],
    },
    {
        en: "In conclusion",
        ru: "В заключение",
        topic: "intro",
        altEn: ["lastly", "last", "finally", "in the end", "in fine"],
        altRu: ["наконец", "в завершение"],
    },
    {
        en: "In fact",
        ru: "На самом деле",
        topic: "intro",
        altEn: ["the fact is that", "the fact is", "actually",
                "in reality", "as a matter of fact"],
        altRu: ["в действительности", 
                "фактически", "в сущности", "в самом деле"],
    },
    {
        en: "In my opinion",
        ru: "По моему мнению",
        topic: "intro",
        altEn: ["in my view", "i hold the view that"],
        altRu: ["по моему", "помоему", "на мой взгляд"],
    },
    {
        en: "In other words",
        ru: "Другими словами",
        topic: "intro",
        altEn: ["to put it another way"],
        altRu: ["иначе говоря"],
    },
    {
        en: "In particular",
        ru: "В частности",
        topic: "intro",
        altEn: ["particularly", "especially"],
        altRu: ["в особенности", "особенно", ],
    },
    {
        en: "In short",
        ru: "Короче говоря",
        topic: "intro",
        altEn: ["in brief", "briefly", "in fine", "all in all",
                "in a word", "in one word", "in sum",
                "to make a long story short",
                "to cut a long story short"],
        altRu: ["короче", "словом", "одним словом", "вкратце",
                "в двух словах"],
    },
    {
        en: "In spite of this",
        ru: "Несмотря на это",
        topic: "intro",
        altEn: ["despite this", "in defiance of this", "even so", 
                "nevertheless", "that said"],
        altRu: ["тем не менее", "невзирая на это", "вопреки этому"],
    },
    {
        en: "It seems that…",
        ru: "Кажется, что…",
        topic: "intro",
        altEn: ["it seems"],
        altRu: ["похоже что", "кажется", "похоже"],
    },
    {
        en: "It's considered that…",
        ru: "Считается, что…",
        topic: "intro",
        altEn: ["it is thought that", "its thought that",
                "it is believed that", "its believed that",
                "it is considered that"],
        altRu: ["считают что", "принято считать что"],
    },
    {
        en: "Keep in mind that…",
        ru: "Имей в виду, что…",
        topic: "intro",
        altEn: ["bear in mind that"],
        altRu: ["имейте в виду что",
                "принимай во внимание что",
                "принимайте во внимание что",
                "помни что", "помните что",
                "не забывай что", "не забывайте что",
                "учтите что", "учти что", 
                "учитывайте что", "учитывай что"],
    },
    {
        en: "Needless to say",
        ru: "Разумеется",
        topic: "intro",
        altEn: ["selfevidently", "obviously", "naturally", "surely",
                "it goes without saying", "of course"],
        altRu: ["само собой", "естественно", "безусловно",
                "само собой разумеется",
                "не приходится и говорить", 
                "нет нужды говорить"],
    },
    {
        en: "Not to mention…",
        ru: "Не говоря уже про…",
        topic: "intro",
        altEn: ["not to speak of", "say nothing of", 
                "to say nothing of"],
        altRu: ["не говоря уже о", "не говоря о", "не говоря про",
                "не считая", "не упоминая", "не упоминая о",
                "не упоминая про"],
    },
    {
        en: "On the contrary…",
        ru: "Напротив…",
        topic: "intro",
        altEn: ["to the contrary", "by contrast"],
        altRu: ["наоборот", "отнюдь"],
    },
    {
        en: "On the one hand… On the other hand…",
        ru: "С одной стороны… С другой стороны…",
        topic: "intro",
        altEn: ["on one hand on the other",
                "on the one hand on the other",
                "on one hand on the other hand"],
        altRu: ["с одной стороныс другой стороны"],
    },
    {
        en: "One way or the other",
        ru: "Так или иначе",
        topic: "intro",
        altEn: ["either way", "one way or another", 
                "somehow or other", "anyhow", "anyway",
                "in any event"],
        altRu: ["тем или иным путем", "тем или иным способом", 
                "тем или иным образом", "тем или другим путем", 
                "тем или другим способом", 
                "тем или другим образом", "в любом случае"],
    },
    {
        en: "Provided that…",
        ru: "При условии, что…",
        topic: "intro",
        altEn: ["on the condition that", 
        "given that", "providing", "provided",
        "sobeit", "in case if", "only in case if"],
        altRu: ["в том случае если", "случае если", "если только",
                "при условии если", "в случае если", "только если"],
    },
    {
        en: "So to speak",
        ru: "Так сказать",
        topic: "intro",
        altEn: ["if you will", 
                "in a manner of speaking", "so to say"],
        altRu: ["что называется", "можно сказать", 
                "с позволения сказать", "если хотите"],
    },
    {
        en: "Sorry to say",
        ru: "К сожалению",
        topic: "intro",
        altEn: ["regretfully", "unfortunately", "unluckily",
                "sadly", "unhappily"],
        altRu: ["жаль это говорить", 
                "к несчастью"],
    },
    {
        en: "That is",
        ru: "То есть",
        topic: "intro",
        altEn: ["that is to say", "thats", "thats to say"],
        altRu: ["другими словами", "иначе говоря",
                "если точнее", "точнее говоря",
                "если говорить точнее", "точнее сказать",
                "сказать точнее"],
    },
    {
        en: "The bottom line is that…",
        ru: "Суть в том, что…",
        topic: "intro",
        altEn: ["the fact is that", "the thing is", "the fact is", 
                "in point of fact", "the bottom line is"],
        altRu: ["дело в том что", "правда в том что", 
                "суть в том что", "истина в том что"],
    },
    {
        en: "The only thing is",
        ru: "Единственное что",
        topic: "intro",
        altEn: ["the thing is"],
        altRu: ["дело в том", "единственное"],
    },
    {
        en: "Therefore",
        ru: "Таким образом",
        topic: "intro",
        altEn: ["thus", "so", "thereby", "as a consequence", 
                "consequently", "accordingly", "in this manner",
                "hence", "thence", "whence", "for that reason"],
        altRu: ["поэтому", "следовательно", "значит",
                "в этом случае", "в связи с этим", "в этой связи"],
    },
    {
        en: "To be honest",
        ru: "Если честно",
        topic: "intro",
        altEn: ["frankly speaking", "speaking quite frankly",
                "quite frankly", "speaking frankly",
                "honestly", "and honestly"],
        altRu: ["честно говоря", "откровенно говоря", 
                "говоря откровенно", "если говорить откровенно",
                "сказать по правде", "по правде сказать",
                "по правде говоря", "если быть честным",
                "честно сказать", "сказать честно", "честное слово"],
    },
    {
        en: "To the best of my knowledge",
        ru: "Насколько мне известно",
        topic: "intro",
        altEn: ["as far as i know", 
                "for the best of my belief", 
                "for the best of my knowledge",
                "for all i know", "for aught i know"],
        altRu: ["насколько я знаю",
                "насколько я могу знать"],
    },
    {
        en: "Turns out",
        ru: "Оказывается",
        topic: "intro",
        altEn: ["it turns out", "it turns out that", "turns out that"],
        altRu: ["в действительности", "на практике",
                "оказалось", "оказалось что", "оказывается что"],
    },
    {
        en: "What's more",
        ru: "Кроме того",
        topic: "intro",
        altEn: ["what is more", "furthermore", "in addition", "also",
                "moreover", "besides"],
        altRu: ["более того", "к тому же"],
    },
    {
        en: "You know",
        ru: "Как бы сказать",
        topic: "intro",
        altEn: ["how to put it in the right words", 
                "thats a good question",
                "that is a good question",
                "how do you say",
                "how do i say",
                "how shall i say",
                "howll i say"],
        altRu: ["как бы это сказать", "как это сказать",
                "знаешь ли", "ты знаешь", "как бы сказать точнее",
                "как бы точнее сказать", "понимаешь ли", "понимаете ли", 
                "понимаешь", "понимаете"],
    },
    {
        en: "You see",
        ru: "Видишь ли",
        topic: "intro",
        altEn: [],
        altRu: ["видите ли", "понимаешь", "понимаешь ли", "понимаете"],
    },
    {
        en: "Can't argue with that",
        ru: "Не могу с этим спорить",
        topic: "consent",
        altEn: ["can not argue with that",
                "i can not argue with that", "i cant argue with that",
                "can not argue with it",
                "i can not argue with it", "i cant argue with it"],
        altRu: ["с этим не поспорить", "с этим не поспоришь",
                "не могу с этим спорить", "не могу это оспорить",
                "не могу спорить с этим","не могу оспорить это",
                "с этим сложно спорить", "с этим трудно спорить",
                "я не могу с этим спорить", "я не могу это оспорить",
                "я не могу спорить с этим", "я не могу оспорить это"],
    },
    {
        en: "Deal!",
        ru: "По рукам!",
        topic: "consent",
        altEn: ["thats a bargain", "that is a bargain", "agreed",
                "its a bargain", "it is a bargain"],
        altRu: ["договорились", "идет"],
    },
    {
        en: "Enough said!",
        ru: "И не говори!",
        topic: "consent",
        altEn: ["nuff said", "nuf said", "say no more"],
        altRu: ["это точно"],
    },
    {
        en: "Exactly!",
        ru: "Именно так!",
        topic: "consent",
        altEn: ["absolutely", "quite so", "precisely"],
        altRu: ["точно", "это точно", "точно так", "именно"],
    },
    {
        en: "Great idea!",
        ru: "Отличная мысль!",
        topic: "consent",
        altEn: ["good idea"],
        altRu: ["отличная идея", 
                "великолепная идея", "великолепная мысль",
                "замечательная идея", "замечательная мысль",
                "прекрасная идея", "прекрасная мысль",
                "чудесная идея", "чудесная мысль"],
    },
    {
        en: "I agree with you",
        ru: "Я согласен с вами",
        topic: "consent",
        altEn: [],
        altRu: ["я согласен с тобой", "я с вами согласен",
                "я с тобой согласен", "согласен с вами", 
                "согласен с тобой", "я согласна с вами", 
                "я согласна с тобой", "я с вами согласна",
                "я с тобой согласна", "согласна с вами", 
                "согласна с тобой"],
    },
    {
        en: "I beg to differ",
        ru: "Позволю себе не согласиться",
        topic: "consent",
        altEn: [],
        altRu: ["я позволю себе не согласиться",
                "я вынужден не согласиться",
                "я осмелюсь не согласиться",
                "я позволю себе смелость не согласиться",
                "я возьму на себя смелость не согласиться",
                "вынужден не согласиться",
                "осмелюсь не согласиться",
                "позволю себе смелость не согласиться",
                "возьму на себя смелость не согласиться"],
    },
    {
        en: "I doubt it",
        ru: "Я сомневаюсь в этом",
        topic: "consent",
        altEn: ["i have doubts about this", "ive doubts about this",
                "i have doubts about it", "ive doubts about it",
                "i have doubts about that", "ive doubts about that"],
        altRu: ["сомневаюсь в этом", "я сомневаюсь",
                "я в этом сомневаюсь",
                "сомневаюсь насчет этого", 
                "я сомневаюсь насчет этого", ],
    },
    {
        en: "I guess so",
        ru: "Полагаю, что так",
        topic: "consent",
        altEn: ["i think so", "i suppose so"],
        altRu: ["полагаю это так", "полагаю что это так", 
                "я полагаю что так", "я полагаю это так", 
                "я полагаю что это так",
                "думаю что так", "думаю это так", 
                "полагаю что это так", 
                "я думаю что так", "я думаю это так", 
                "я думаю что это так",
                "считаю что так", "считаю это так", 
                "считаю что это так", 
                "я считаю что так", "я считаю это так", 
                "я считаю что это так"],
    },
    {
        en: "I think so too",
        ru: "Я тоже так думаю",
        topic: "consent",
        altEn: ["i guess so too", "i suppose so too"],
        altRu: ["я думаю так же", "я тоже думаю так",
                "я тоже так полагаю"],
    },
    {
        en: "I totally disagree",
        ru: "Я совершенно не согласен",
        topic: "consent",
        altEn: ["i completely disagree", "i absolutely disagree",
                "i wholly disagree", "i strongly disagree", ],
        altRu: ["я полностью не согласен", "я абсолютно не согласен", 
                "совершенно не согласен", "полностью не согласен", 
                "абсолютно не согласен", 
                "я совершенно не согласна", "я полностью не согласна", 
                "я абсолютно не согласна", "совершенно не согласна",
                "полностью не согласна", "абсолютно не согласна"],
    },
    {
        en: "I'm afraid you are wrong",
        ru: "Боюсь, что вы не правы",
        topic: "consent",
        altEn: ["im afraid youre wrong",
                "i am afraid you are wrong", "i am afraid youre wrong"],
        altRu: ["я боюсь что вы не правы", "я боюсь что ты не прав",
                "боюсь что ты не прав",
                "боюсь что вы ошибаетесь", "боюсь что ты ошибаешься",
                "я боюсь что вы ошибаетесь", "я боюсь что ты ошибаешься",
                "боюсь вы ошибаетесь", "боюсь ты ошибаешься"],
    },
    {
        en: "I'm in!",
        ru: "Я за!",
        topic: "consent",
        altEn: ["include me", "count me in"],
        altRu: ["я с вами"],
    },
    {
        en: "I'm not sure",
        ru: "Я не уверен",
        topic: "consent",
        altEn: ["i am not sure"],
        altRu: ["не уверен", "я не уверена", "не уверена"],
    },
    {
        en: "In a way",
        ru: "В каком-то смысле",
        topic: "consent",
        altEn: ["in one way", "in some way", "in a sense"],
        altRu: ["в какойто степени", "в определенной степени",
                "в какомто смысле", "в какой то степени", 
                "в каком то смысле", "в некоторой степени",
                "в некотором смысле", "в некотором отношении",
                "в известной степени", "в известном смысле",
                "в известном отношении", "в определеном отношении",
                "в определенном смысле"],
    },
    {
        en: "In large measure",
        ru: "В значительной мере",
        topic: "consent",
        altEn: ["to a large extent", "to a large degree",
                "to a great extent", "to a great degree",
                "in great measure", "largery", ],
        altRu: ["в значительной степени", "весьма", "значительно"],
    },
    {
        en: "May be",
        ru: "Может быть",
        topic: "consent",
        altEn: ["maybe", "perhaps", "possibly", "perchance"],
        altRu: ["возможно"],
    },
    {
        en: "Most likely",
        ru: "Скорее всего",
        topic: "consent",
        altEn: ["very likely", "likely", "probably"],
        altRu: ["наиболее вероятно", "наверняка", "с наибольшей вероятностью"],
    },
    {
        en: "No doubt",
        ru: "Без сомнения",
        topic: "consent",
        altEn: ["without a doubt", "without doubt", "beyond doubt", 
                "undoubtedly", "doubtless"],
        altRu: ["без сомнений", "нет сомнений", "нет сомнения",
                "никаких сомнений", "никакого сомнения",
                "несомненно", "вне сомнений", "вне сомнения",
                "вне всяких сомнений", "вне всякого сомнения"],
    },
    {
        en: "No way!",
        ru: "Ни за что!",
        topic: "consent",
        altEn: ["nowise", "in no case", "in no event", "in no way",
                "in no degree"],
        altRu: ["ни в коем случае", "никоим образом", " да ладно",
                "ни в коей степени"],
    },
    {
        en: "Not a bit",
        ru: "Ничуть",
        topic: "consent",
        altEn: ["not a bit", "not at all", "not in the least",
                "certainly not", "absolutely not"],
        altRu: ["вовсе нет", "нисколько", "никоим образом",
                "отнюдь", "ни в коей степени",
                "ни в малейшей степени", "совсем нет"],
    },
    {
        en: "Not necessarily",
        ru: "Не обязательно",
        topic: "consent",
        altEn: ["its not necessarily", "it is not necessarily"],
        altRu: ["необязательно"],
    },
    {
        en: "Not quite",
        ru: "Не совсем",
        topic: "consent",
        altEn: ["not exactly"],
        altRu: ["не совсем так", "не вполне"],
    },
    {
        en: "Of course",
        ru: "Конечно",
        topic: "consent",
        altEn: ["sure", "certainly", "surely", " definitely",
                "naturally", "clearly"],
        altRu: ["разумеется", "естественно", "конечно же",
                "само собой"],
    },
    {
        en: "That would be great!",
        ru: "Это было бы прекрасно!",
        topic: "consent",
        altEn: ["thatd be great", "itd be great", "it would be great"],
        altRu: ["было бы прекрасно",
                "это было бы здорово", "было бы здорово",
                "это было бы великолепно",
                "было бы великолепно",
                "это было бы замечательно",
                "было бы замечательно",
                "это было бы отлично", "было бы отлично"],
    },
    {
        en: "That's for sure!",
        ru: "Это уж точно!",
        topic: "consent",
        altEn: ["that is for sure", "for sure", "it is for sure", "its for sure"],
        altRu: ["это точно"],
    },
    {
        en: "Up to a point",
        ru: "До некоторой степени",
        topic: "consent",
        altEn: ["up to a certain point", "to some extent", "somewhat",
                "in some measure", "to some extent", "to some degree",
                "to a certain degree", "to a certain extent"],
        altRu: ["до известной степени", "до определенной степени", 
                "в известной степени", "в некоторой степени", 
                "в какойто степени", "в определенной степени",
                "до определенного момента", 
                "в некотором отношении", "в какомто отношении",
                "в определенном отношении", 
                "отчасти", "в некотором роде", "в какомто роде"],
    },
    {
        en: "You are absolutely right!",
        ru: "Вы совершенно правы!",
        topic: "consent",
        altEn: ["youre absolutely right", "you are quite right", "youre quite right",
                "you are completely right", "youre completely right",
                "you are definitely right", "youre definitely right"],
        
        altRu: ["ты совершенно прав", "вы абсолютно правы", 
                "ты абсолютно прав", "вы полностью правы", 
                "ты полностью прав", "ты совершенно права", 
                "ты абсолютно права", "ты полностью права"],
    },
    {
        en: "You have a point there",
        ru: "Ваша идея не лишена смысла",
        topic: "consent",
        altEn: ["you have a point", "youve a point there", "youve a point",
                "youve got a point there", "youve got a point", 
                "you have got a point there", "you have got a point",
                "your idea makes sense", 
                "your idea is not meaningless", "your ideas not meaningless",
                "your idea is not devoid of meaning", "your idea isnt devoid of meaning",
                "your ideas not devoid of meaning"],
        altRu: ["твоя идея не лишена смысла", 
                "ваша точка зрения не лишена смысла",
                "твоя точка зрения не лишена смысла",
                "ваше предложение не лишено смысла",
                "твое предложение не лишено смысла",
                "ваши слова не лишены смысла",
                "ваша мысль не лишена смысла",
                "ваши соображения не лишены смысла",
                "твои слова не лишены смысла",
                "твоя мысль не лишена смысла",
                "твои соображения не лишены смысла",
                "в вашем предложении есть смысл",
                "в твоем предложении есть смысл",
                "в ваших словах есть смысл",
                "в твоих словах есть смысл",
                "в ваших соображениях есть смысл",
                "в твоих соображениях есть смысл",
                "ваша точка зрения имеет смысл",
                "ваша идея имеет смысл",
                "в вашей идее есть смысл",
                "твоя точка зрения имеет смысл",
                "твоя идея имеет смысл",
                "в твоей идее есть смысл",
                "ваше предложение имеет смысл",
                "твое предложение имеет смысл",
                "в этом есть смысл", "это имеет смысл",
                "тут вы правы", "тут ты прав",
                "здесь вы правы", "здесь ты прав",
                "вы правы здесь", "ты прав здесь",
                "вы правы насчет этого", "ты прав насчет этого",
                "насчет этого вы правы", "насчет этого ты прав",
                "вы правы на этот счет", "ты прав на этот счет",
                "на этот счет вы правы", "на этот счет ты прав"],
    },
    {
        en: "You took the words out of my mouth!",
        ru: "Вы сняли эти слова с моего языка!",
        topic: "consent",
        altEn: ["you took the words right out of my mouth",
                "you took these words right out of my mouth",
                "you took these words out of my mouth"],
        altRu: ["ты снял эти слова с моего языка",
                "вы сняли эти слова у меня с языка", "ты снял эти слова у меня с языка",
                "вы сняли это с моего языка", "ты снял это с моего языка", 
                "вы сняли это у меня с языка", "ты снял это у меня с языка",
                "вы сняли слова с моего языка", "ты снял слова с моего языка",
                "вы сняли слова у меня с языка", "ты снял слова у меня с языка",
                "ты сняла эти слова с моего языка", "ты сняла эти слова у меня с языка",
                "ты сняла это с моего языка", "ты сняла это у меня с языка",
                "ты сняла слова с моего языка", "ты сняла слова у меня с языка"],
    },
    {
        en: "Actually, I would prefer to…",
        ru: "На самом деле, я бы предпочел…",
        topic: "courtesy",
        altEn: ["actually id rather", "actually id prefer to",
                "actually i would rather",
                 "actually id prefer",  "actually i would prefer"],
        altRu: ["на самом деле я предпочел бы", 
                "в действительности я предпочел бы",
                "в действительности я бы предпочел",
                "на самом деле я бы предпочла",
                "на самом деле я предпочла бы", 
                "в действительности я предпочла бы",
                "в действительности я бы предпочла"],
    },
    {
        en: "After you!",
        ru: "После вас!",
        topic: "courtesy",
        altEn: [],
        altRu: ["после тебя"],
    },
    {
        en: "Bless you!",
        ru: "Будьте здоровы!",
        topic: "courtesy",
        altEn: ["god bless you"],
        altRu: ["будь здоров", "не болей", "не болейте",
                "храни вас бог", "храни тебя бог",
                "да хранит вас бог", "да хранит тебя бог",
                "да благословит тебя бог", "благослови тебя бог",
                "да благословит вас бог", "благослови вас бог",
                "бог вас благослови", "бог тебя благослови", 
                "боже мой", "бог мой", "бог ты мой", 
                "доброго здоровья", "будь здорова",
                "доброго вам здоровья", "доброго тебе здоровья"],
    },
    {
        en: "Congratulations!",
        ru: "Мои поздравления!",
        topic: "courtesy",
        altEn: ["сongrats", "my congratulations", "my congrats"],
        altRu: ["поздравляю", "поздравляем"],
    },
    {
        en: "Excuse me!",
        ru: "Извините!",
        topic: "courtesy",
        altEn: ["sorry", "i beg your pardon", "pardon me", 
                "im sorry", "i am sorry"],
        altRu: ["извините меня", "простите меня", 
                "извините", "простите", "виноват",
                "извини меня", "прости меня", 
                "извини", "прости"],
    },
    {
        en: "Help yourself!",
        ru: "Угощайтесь!",
        topic: "courtesy",
        altEn: [],
        altRu: ["прошу", "берите", "угощайся"],
    },
    {
        en: "I am so sorry!",
        ru: "Мне так жаль!",
        topic: "courtesy",
        altEn: ["im so sorry", "condolences", "my condolences", 
                "condolence", "my condolence"],
        altRu: ["мне очень жаль", "сожалею", "я сожалею",
                "я так сожалею", "примите мои соболезнования",
                "прими мои соболезнования", 
                "мои соболезнования"],
    },
    {
        en: "I beg your pardon!",
        ru: "Прошу прощения!",
        topic: "courtesy",
        altEn: ["sorry", "excuse me", "pardon me", "im sorry", "i am sorry"],
        altRu: ["извините меня", "простите меня", 
                "извините", "простите",
                "извините пожалуйста", "простите пожалуйста",
                "извините меня пожалуйста", 
                "простите меня пожалуйста", 
                "извини меня", "прости меня", 
                "извини", "прости", 
                "приношу извинения", "мои извинения"],
    },
    {
        en: "I owe you one!",
        ru: "Я твой должник!",
        topic: "courtesy",
        altEn: ["i owe you"],
        altRu: ["я у тебя в долгу", "я в долгу перед тобой",
                "я перед тобой в долгу", "я ваш должник",
                "я у вас в долгу", "я в долгу перед вами",
                "я перед вами в долгу", 
                "я твоя должница", "я ваша должница"],
    },
    {
        en: "I really appreciate it!",
        ru: "Я очень ценю это!",
        topic: "courtesy",
        altEn: ["i really appreciate this"],
        altRu: ["я действительно ценю это",
                "я понастоящему ценю это",
                "я по настоящему ценю это"],
    },
    {
        en: "I took the liberty to…",
        ru: "Я взял на себя смелость…",
        topic: "courtesy",
        altEn: ["i took the liberty of", 
                "i have taken the liberty to", "i have taken the liberty of",
                "ive taken the liberty to", "ive taken the liberty of"],
        altRu: ["я позволил себе", "я позволил себе смелость", "я осмелился",
                "я взяла на себя смелость",
                "я позволила себе", "я позволила себе смелость",
                "я осмелилась"],
    },
    {
        en: "I wish I could but…",
        ru: "Я бы с удовольствием, но…",
        topic: "courtesy",
        altEn: [],
        altRu: ["я бы с радостью но", "я бы сам хотел но",
                "я бы и сам хотел но",
                "я бы сама хотела но",
                "я бы и сама хотела но"],
    },
    {
        en: "I'm so happy for you!",
        ru: "Я так рад за вас!",
        topic: "courtesy",
        altEn: ["i am so happy for you"],
        altRu: ["я так счастлив за тебя", "я так счастлив за вас",
                "я так рад за тебя", 
                "я так рада за вас", "я так счастлива за тебя", 
                "я так счастлива за вас", "я так рада за тебя"],
    },
    {
        en: "I'm sorry to hear that",
        ru: "Мне жаль это слышать",
        topic: "courtesy",
        altEn: ["i am sorry to hear that", "im sorry to hear that",
                "condolences", "my condolences",
                "condolence", "my condolence"],
        altRu: ["жаль это слышать", "примите мои соболезнования",
                "прими мои соболезнования", "мои соболезнования"],
    },
    {
        en: "It's all right",
        ru: "Всё в порядке",
        topic: "courtesy",
        altEn: ["it is all right", "that is all right", "thats all right", 
                "nothing wrong", "theres nothing wrong", "there is nothing wrong"],
        altRu: ["все нормально", "все хорошо", "ничего страшного"],
    },
    {
        en: "It's my pleasure!",
        ru: "Обращайтесь!",
        topic: "courtesy",
        altEn: ["it is my pleasure", "it was my pleasure", 
                "my pleasure", "it is a pleasure", "its a pleasure",
                "youre welcome", "you are welcome", "my pleasure",
                "it is a pleasure for me", "its a pleasure for me"],
        altRu: ["обращайся", "рад помочь", "рад был помочь", "был рад помочь",
                "буду рад оказаться полезным", 
                "рад буду помочь", "буду рад помочь",
                "раб быть полезен", "рад быть полезным",
                "рад был оказаться полезным", 
                "был рад оказаться полезным", 
                "рад был оказаться полезен", 
                "был рад оказаться полезен",
                "был рад принести пользу", "рад принести пользу", 
                "буду рад принести пользу",
                "не за что", "не стоит благодарности"],
    },
    {
        en: "It's very kind of you!",
        ru: "Это очень мило с вашей стороны!",
        topic: "courtesy",
        altEn: ["it is very kind of you", "so nice of you", 
                "it is so nice of you", "its so nice of you",
                "its very nice of you", "it is very nice of you",
                "so nice of you", "very kind of you"],
        altRu: ["это очень любезно с вашей стороны",
                "это так мило с вашей стороны",
                "это так любезно с вашей стороны",
                "очень мило с вашей стороны",
                "очень любезно с вашей стороны",
                "так мило с вашей стороны",
                "так любезно с вашей стороны",
                "это очень любезно с твоей стороны",
                "это так мило с твоей стороны",
                "это так любезно с твоей стороны",
                "очень мило с твоей стороны",
                "очень любезно с твоей стороны",
                "так мило с твоей стороны",
                "так любезно с твоей стороны",
                "это очень мило с твоей стороны"],
    },
    {
        en: "Let me know when…",
        ru: "Дайте знать, когда…",
        topic: "courtesy",
        altEn: [],
        altRu: ["дайте мне знать когда", "сообщите когда",
                "дай мне знать когда", "сообщи когда",
                "дай знать когда", 
                "дай знать если", "дайте знать если",
                "дайте мне знать если", "сообщите если",
                "дай мне знать если", "сообщи если"],
    },
    {
        en: "May I help you with…?",
        ru: "Могу ли я помочь вам с…?",
        topic: "courtesy",
        altEn: ["can i help you with"],
        altRu: ["могу ли я помочь тебе с",  
                "я могу помочь вам с", "я могу помочь тебе с",
                "позвольте помочь вам с", "позволь помочь тебе с", 
                "позволите помочь вам с", "позволишь помочь тебе с",
                "не позволите помочь вам с", "не позволишь помочь тебе с",
                "позвольте мне помочь вам с", "позволь мне помочь тебе с", 
                "позволите мне помочь вам с", "позволишь мне помочь тебе с",
                "не позволите мне помочь вам с", "не позволишь мне помочь тебе с"],
    },
    {
        en: "No problem!",
        ru: "Никаких проблем!",
        topic: "courtesy",
        altEn: ["not a problem", "nothing wrong", 
                "theres nothing wrong", "there is nothing wrong"],
        altRu: ["нет проблем", "без проблем"],
    },
    {
        en: "Don't mention it!",
        ru: "Не стоит благодарности!",
        topic: "courtesy",
        altEn: ["not at all", "do not mention it", "forget it",
                "you are welcome", "youre welcome", "if you please"],
        altRu: ["не за что", "пустяки", "не обращайте внимания", "пожалуйста", "ерунда"],
    },
    {
        en: "Nothing wrong!",
        ru: "Ничего страшного!",
        topic: "courtesy",
        altEn: ["it is all right", "that is all right", "thats all right", 
                "nothing wrong", "theres nothing wrong",
                "there is nothing wrong", "its all right"],
        altRu: ["все нормально", "все хорошо", "все в порядке", 
                "никаких проблем"],
    },
    {
        en: "One good turn deserves another!",
        ru: "Услуга за услугу!",
        topic: "courtesy",
        altEn: ["you scratch my back ill scratch yours",
                "you scratch my back i will scratch yours",
                "you scratch my back and ill scratch yours",
                "you scratch my back and i will scratch yours",
                "quid pro quo"],
        altRu: ["ты мне я тебе", "вы мне я вам"],
    },
    {
        en: "Please note",
        ru: "Пожалуйста, обратите внимание",
        topic: "courtesy",
        altEn: ["attention please", "your attention please"],
        altRu: ["обратите внимание"],
    },
    {
        en: "Sorry for keeping you waiting",
        ru: "Простите, что заставил вас ждать",
        topic: "courtesy",
        altEn: ["sorry to have kept you waiting",
                "i am sorry for keeping you waiting",
                "im sorry for keeping you waiting",
                "i am sorry to have kept you waiting",
                "im sorry to have kept you waiting"],
        altRu: ["извините что заставил вас ждать",
                "простите за ожидание", "извините за ожидание",
                "прости что заставил тебя ждать",
                "извини что заставил тебя ждать",
                "прости что заставил ждать",
                "простите что заставил ждать",
                "извини что заставил ждать",
                "извините что заставил ждать",
                "простите что заставила вас ждать",
                "извините что заставила вас ждать",
                "прости что заставила тебя ждать",
                "извини что заставила тебя ждать",
                "прости что заставила ждать",
                "простите что заставила ждать",
                "извини что заставила ждать",
                "извините что заставила ждать"],
    },
    {
        en: "Sorry to bother you",
        ru: "Простите, что беспокою вас",
        topic: "courtesy",
        altEn: ["sorry to disturb you",
                "sorry for bothering you", "sorry for disturbing you",
                "im sorry to bother you", "im sorry to disturb you",
                "im sorry for bothering you", "im sorry for disturbing you",
                "i am sorry to bother you", "i am sorry to disturb you",
                "i am sorry for bothering you", "i am sorry for disturbing you"],
        altRu: ["простите за беспокойство", "извините за беспокойство",
                "прошу прощения за беспокойство", "приношу извинения за беспокойство",
                "извините что беспокою вас", "простите что беспокою вас",
                "извини что беспокою тебя", "прости что беспокою тебя",
                "простите что побеспокоил вас", "извините что побеспокоил вас", 
                "прости что побеспокоил тебя", "извини что побеспокоил тебя", 
                "прости что беспокою", "простите что беспокою",
                "извини что беспокою", "извините что беспокою",
                "прости что побеспокоил", "простите что побеспокоил",
                "извини что побеспокоил", "извините что побеспокоил",
                "простите что побеспокоила вас", "извините что побеспокоила вас", 
                "прости что побеспокоила тебя", "извини что побеспокоила тебя", 
                "прости что побеспокоила", "простите что побеспокоила",
                "извини что побеспокоила", "извините что побеспокоила"],
    },
    {
        en: "Sorry to interrupt, but…",
        ru: "Простите, что прерываю, но…",
        topic: "courtesy",
        altEn: ["sorry for interrupting but", 
                "sorry for interrupting you but", "sorry to interrupt you but",
                "im sorry to interrupt but", "im sorry for interrupting but", 
                "im sorry for interrupting you but", "im sorry to interrupt you but",
                "i am sorry to interrupt but", "i am sorry for interrupting but", 
                "i am sorry for interrupting you but", "i am sorry to interrupt you but"],
        altRu: ["извините что прерываю но", "извини что прерываю но",
                "прости что прерываю но"],
    },
    {
        en: "Sorry, I meant well",
        ru: "Простите, я хотел как лучше",
        topic: "courtesy",
        altEn: [],
        altRu: ["извините я хотел как лучше", 
                "извини я хотел как лучше",
                "прости я хотел как лучше",
                "простите я хотела как лучше",
                "извините я хотела как лучше", 
                "извини я хотела как лучше",
                "прости я хотела как лучше"],
    },
    {
        en: "Thank you anyway!",
        ru: "В любом случае, спасибо!",
        topic: "courtesy",
        altEn: ["anyway thanks"],
        altRu: ["все равно спасибо", "спасибо в любом случае",
                "в любом случае спасибо вам", 
                "в любом случае спасибо тебе", 
                "спасибо вам в любом случае", 
                "спасибо тебе в любом случае", 
                "все равно спасибо вам", "все равно спасибо тебе"],
    },
    {
        en: "Thank you in advance!",
        ru: "Заранее спасибо!",
        topic: "courtesy",
        altEn: ["thanks in advance"],
        altRu: ["заранее спасибо вам", "заранее спасибо тебе",
                "спасибо вам заранее", "спасибо тебе заранее"],
    },
    {
        en: "Thanks for asking!",
        ru: "Спасибо, что спросили!",
        topic: "courtesy",
        altEn: ["thank you for asking", 
                "thanks to ask", "thank you to ask"],
        altRu: ["спасибо что спросил", 
                "спасибо за то что спросили", 
                "спасибо за то что спросил",
                "спасибо за вопрос", "спасибо что спрашиваете", 
                "спасибо что спросила", "спасибо за то что спросила"],
    },
    {
        en: "Thanks so much!",
        ru: "Большое спасибо!",
        topic: "courtesy",
        altEn: ["thank you so much", "many thanks", "thanks a lot",
                "thank you very much", "thanks a bunch", 
                "thank you a lot", "thanks a million"],
        altRu: ["большое тебе спасибо", "большое вам спасибо", 
                "большое спасибо тебе", "большое спасибо вам",
                "огромное спасибо"],
    },
    {
        en: "This way, please!",
        ru: "Сюда, пожалуйста!",
        topic: "courtesy",
        altEn: ["come here please", "here please"],
        altRu: ["сюда", "прошу сюда", "сюда прошу", 
                "сюда прошу вас", "прошу вас сюда"],
    },
    {
        en: "Would you like a cup of tea?",
        ru: "Не желаете ли чашечку чая?",
        topic: "courtesy",
        altEn: ["do you want a cup of tea"],
        altRu: ["не хотите ли чашечку чая", "не хотите чашечку чая",
                "не хотите ли чашку чая", "не хотите чашку чая",
                "не желаете ли чашку чая", "не желаете чашку чая",
                "не хочешь ли чашечку чая", "не хочешь чашечку чая",
                "не хочешь ли чашку чая", "не хочешь чашку чая",
                "хочешь чашечку чая", "хотите чашечку чая",
                "хочешь чашку чая", "хотите чашку чая",
                "не хотите ли вы чашечку чая", "не хотите ли вы чашку чая",
                "не желаете ли вы чашку чая", "не желаешь ли ты чашку чая", 
                "не хочешь ли ты чашечку чая", "не хочешь ли ты чашку чая",
                "хочешь ли ты чашечку чая", "хотите ли вы чашечку чая",
                "хочешь ли ты чашку чая", "хотите ли вы чашку чая",
                "желаешь ли ты чашечку чая", "желаешь ли ты чашку чая",
                "желаете ли вы чашечку чая", "желаете ли вы чашку чая",
                "не желаешь чашечку чая", "не желаешь чашку чая",
                "не желаете чашечку чая", "не желаете чашку чая",
                "не желаешь ли чашечку чая", "не желаешь ли чашку чая",
                "не желаете ли чашечку чая", "не желаете ли чашку чая"],
    },
    {
        en: "Would you mind if…?",
        ru: "Не возражаете, если…?",
        topic: "courtesy",
        altEn: ["do you mind if", ],
        altRu: ["не возражаешь если", 
                "ты не возражаешь если", "вы не возражаете если",
                "ты не против если", "вы не против если", 
                "ты не будешь против если", "вы не будете против если",
                "ты не будешь возражать если", "вы не будете возражать если",
                "ты не возражаешь если", "вы не возражаете если", 
                "вы не станете возражать если", "ты не станешь возражать если",
                "не будете возражать если", "не будешь возражать если",
                "не будешь ли ты возражать если", "не будете ли вы возражать если",
                "не станете возражать если", "не станешь возражать если",
                "не станете ли вы возражать если", "не станешь ли ты возражать если"],
    },
    {
        en: "And how about you?",
        ru: "А как насчет тебя?",
        topic: "talk",
        altEn: ["and what about you", "what about you", "how about you"],
        altRu: ["как насчет вас", "как насчет тебя", "а как насчет вас",
                "что насчет тебя", "что насчет вас", 
                "а что насчет тебя", "а что насчет вас", ],
    },
    {
        en: "Did I get you right?",
        ru: "Я правильно тебя понял?",
        topic: "talk",
        altEn: ["did i understand you correctly",
                "have i understand you correctly"],
        altRu: ["я правильно вас понял",
                "я тебя правильно понял", "я вас правильно понял",
                "я правильно тебя поняла", "я правильно вас поняла",
                "я тебя правильно поняла", "я вас правильно поняла",
                "я понял тебя правильно", "я понял вас правильно",
                "я поняла тебя правильно", "я поняла вас правильно"],
    },
    {
        en: "Do you have a better idea?",
        ru: "Есть идея получше?",
        topic: "talk",
        altEn: ["do youve a better idea"],
        altRu: ["у тебя есть идея получше",
                "есть ли у вас идея получше",
                "есть ли у тебя идея получше",
                "у вас есть более хорошая идея",
                "у тебя есть более хорошая идея"],
    },
    {
        en: "Don't take it to heart!",
        ru: "Не принимай это близко к сердцу!",
        topic: "talk",
        altEn: ["do not take it to heart"],
        altRu: ["не принимайте это близко к сердцу",
                "не принимай близко к сердцу",
                "не принимайте близко к сердцу",
                "не принимай это слишком близко к сердцу",
                "не принимайте это слишком близко к сердцу",
                "не принимай слишком близко к сердцу",
                "не принимайте слишком близко к сердцу"],
    },
    {
        en: "Feel free to ask me",
        ru: "Не стесняйтесь спросить меня",
        topic: "talk",
        altEn: ["do not be shy to ask me", "dont be shy to ask me"],
        altRu: ["не стесняйся спросить меня", "не стесняйтесь спрашивать меня",
                "не стесняйся спрашивать меня"],
    },
    {
        en: "Good for you!",
        ru: "Молодец!",
        topic: "talk",
        altEn: ["well done"],
        altRu: ["молодец", "ты молодец", "вы молодец"],
    },
    {
        en: "Has anyone ever…?",
        ru: "Кто-нибудь когда-либо…?",
        topic: "talk",
        altEn: ["has anyone at least once"],
        altRu: ["ктонибудь когдалибо", "ктонибудь когданибудь", "ктото когданибудь", 
                "ктонибудь когдато", "ктото когдато",
                "ктото когдалибо", "ктолибо когдато", 
                "ктолибо когданибудь", "ктолибо когдалибо",
                "ктонибудь хоть раз", "ктолибо хоть раз", 
                "ктонибудь хотя бы раз", "ктолибо хотя бы раз", 
                "ктонибудь хотя бы один раз", "ктолибо хотя бы один раз", 
                "кто когданибудь", "кто когдалибо", "кто хоть раз",
                "кто хотя бы раз", "кто хотя бы один раз"],
    },
    {
        en: "How do you know?",
        ru: "Откуда ты знаешь?",
        topic: "talk",
        altEn: [],
        altRu: ["откуда вы знаете", "откуда вы узнали", "откуда ты узнал", 
                "как ты узнал", "откуда ты узнала", "как ты узнала"],
    },
    {
        en: "I didn't give it much thought",
        ru: "Я не задумывался об этом",
        topic: "talk",
        altEn: ["i did not give it much thought",
                "i have not given it much thought",
                "i havent given it much thought",
                "ive not given it much thought"],
        altRu: ["я об этом не задумывался",
                "я над этим не задумывался",
                "я не задумывался над этим",
                "я не задумывалась об этом",
                "я об этом не задумывалась",
                "я над этим не задумывалась",
                "я не задумывалась над этим"],
    },
    {
        en: "I had a similar experience",
        ru: "У меня был похожий опыт",
        topic: "talk",
        altEn: ["i had similar experience"],
        altRu: ["у меня был подобный опыт",
                "у меня был сходный опыт",
                "я имел похожий опыт",
                "я имел подобный опыт",
                "я имел сходный опыт"],
    },
    {
        en: "I have no idea",
        ru: "Понятия не имею",
        topic: "talk",
        altEn: ["no idea", "ive no idea"],
        altRu: ["я понятия не имею", "без понятия", 
                "у меня нет представления", 
                "никакого представления", 
                "у меня нет никакого представления",
                "не имею никакого представления",
                "я не имею никакого представления"],
    },
    {
        en: "I thought maybe…",
        ru: "Я подумал, может…",
        topic: "talk",
        altEn: ["i thought maybe", "i thought may be", "i was wondering if"],
        altRu: ["я подумал может быть",
                "мне подумалось может", "мне подумалось может быть", 
                "я подумала может", "я подумала может быть"],
    },
    {
        en: "I wonder what if…?",
        ru: "Интересно, что если…?",
        topic: "talk",
        altEn: [],
        altRu: ["интересно а что если", "мне интересно что если", "мне интересно а что если"],
    },
    {
        en: "I'm convinced that…",
        ru: "Я убежден в том, что…",
        topic: "talk",
        altEn: ["i am convinced that",
                "i am confident that", "im confident that",
                "i am positive", "im positive",
                "i am positive that", "im positive that",
                "i am sure", "im sure", "i am sure that", "im sure that",
                "i am certain", "im certain", 
                "i am certain that", "im certain that"],
        altRu: ["я убежден что", 
                "я уверен что", "я уверен в том что",
                "я уверен", "я убежден", "уверен что", "убежден что",
                "я убеждена в том что", "я убеждена что", 
                "я уверена что", "я уверена в том что",
                "я уверена", "я убеждена", "уверена что", "убеждена что"],
    },
    {
        en: "Is that a good thing or a bad thing?",
        ru: "Это хорошо или плохо?",
        topic: "talk",
        altEn: ["is it a good thing or a bad thing",
                "is that a good or a bad thing",
                "is it a good or a bad thing",
                "is it a good or a bad"],
        altRu: ["это хорошо или это плохо"],
    },
    {
        en: "It could be better",
        ru: "Могло быть и лучше",
        topic: "talk",
        altEn: ["could be better"],
        altRu: ["могло быть и получше", "могло быть лучше",
                "может быть лучше", "может быть и получше", 
                "могло бы быть лучше",
                "может быть и лучше"],
    },
    {
        en: "It makes no difference to me",
        ru: "Для меня это не имеет значения",
        topic: "talk",
        altEn: ["it does not make a difference to me",
                "it doesnt make a difference to me",
                "it doesnt matter to me", "it does not matter to me"],
        altRu: ["для меня это не играет роли",
                "это не имеет значения для меня",
                "это не играет роли для меня",
                "мне все равно"],
    },
    {
        en: "Join the club!",
        ru: "Добро пожаловать в клуб!",
        topic: "talk",
        altEn: ["welcome to the club"],
        altRu: [],
    },
    {
        en: "Let me finish",
        ru: "Позвольте мне закончить",
        topic: "talk",
        altEn: [],
        altRu: ["позволь мне закончить", "дайте мне закончить",
                "дай мне закончить", "дай я закончу", 
                "можно мне закончить", "можно я закончу"],
    },
    {
        en: "Let's hope for the best!",
        ru: "Будем надеяться на лучшее!",
        topic: "talk",
        altEn: ["let us hope for the best", "we will hope for the best",
                "well hope for the best"],
        altRu: ["давайте надеяться на лучшее", "давайте будем надеяться на лучшее"],
    },
    {
        en: "Never mind!",
        ru: "Не бери в голову!",
        topic: "talk",
        altEn: ["nevermind", "skip it", "it doesnt matter",
                "it does not matter"],
        altRu: ["неважно", "не важно", "это не имеет значения", 
                "не имеет значения", "не берите в голову", "забудь", 
                "забудьте", "ничего", "ничего такого",
                "ничего страшного", "не обращай внимания", 
                "не обращайте внимания", 
                "это не важно", "это неважно"],
    },
    {
        en: "Next time lucky!",
        ru: "Повезёт в следующий раз!",
        topic: "talk",
        altEn: ["better luck next time", "lucky next time"],
        altRu: ["в следующий раз повезет",
                "повезет в другой раз", "в другой раз повезет"],
    },
    {
        en: "Same as always",
        ru: "Как всегда",
        topic: "talk",
        altEn: ["as always", "always the way",
                "that is always the way", "thats always the way",
                "it is always the way", "its always the way"],
        altRu: ["как и всегда", "так же как и всегда", "так же как всегда", 
                "то же что всегда", "то же что и всегда",
                "то же самое что всегда", "то же самое что и всегда"],
    },
    {
        en: "So that's where the trouble lies!",
        ru: "Так вот в чем проблема!",
        topic: "talk",
        altEn: ["so that is where the trouble lies",
                "thats where the trouble lies",
                "that is where the trouble lies"],
        altRu: ["вот в чем проблема",
                "так вот где проблема", "вот где проблема",
                "так вот в чем была проблема",
                "вот в чем была проблема",
                "так вот где была проблема", 
                "вот где была проблема",
                "вот в чем заключается проблема",
                "так вот в чем заключается проблема",
                "вот в чем заключалась проблема",
                "так вот в чем заключалась проблема"],
    },
    {
        en: "That reminds me…",
        ru: "Это напоминает мне…",
        topic: "talk",
        altEn: ["that reminded me", "it reminds me", "it reminded me"],
        altRu: ["это напомнило мне", "это напоминает",
                "это напоминает мне о", "это напомнило мне о",
                "это напоминает мне про", "это напомнило мне про"],
    },
    {
        en: "That's news to me",
        ru: "Это новость для меня",
        topic: "talk",
        altEn: ["that is news to me", 
                "it is news to me",  "its news to me", 
                "thats new to me", "that is new to me",
                "its new to me", "it is new to me",
                "that is a new one on me", 
                "it is a new one on me", "its a new one on me"],
        altRu: ["это ново для меня", "для меня это новость",
                "для меня это ново", "для меня это что-то новое",
                "для меня это нечто новое", 
                "такого я еще не слышал",  "такого я еще не видел",
                "это что-то новое для меня",
                "это нечто новое для меня",
                "это что-то новенькое"],
    },
    {
        en: "The same thing happened to me",
        ru: "Со мной случилось то же самое",
        topic: "talk",
        altEn: ["i had the same experience", 
                "i have the same experience", "ive the same experience"],
        altRu: ["со мной случилось то же самое", "со мной произошло то же самое",
                "со мной случалось то же самое", "со мной происходило то же самое",
                "со мной было то же самое", "со мной бывало то же самое",
                "то же самое случилось со мной", "то же самое произошло со мной",
                "то же самое случалось со мной", "то же самое происходило со мной",
                "то же самое было со мной", "у меня случилось то же самое",
                "у меня произошло то же самое", "у меня случалось то же самое",
                "у меня происходило то же самое", "у  меня было то же самое",
                "у меня бывало то же самое", "то же самое случилось у меня",
                "то же самое произошло у меня","то же самое случалось у меня",
                "то же самое происходило у меня", "то же самое было у меня"],
    },
    {
        en: "Things happen",
        ru: "Всякое случается",
        topic: "talk",
        altEn: [],
        altRu: ["всякое бывает"],
    },
    {
        en: "This explains a lot",
        ru: "Это многое объясняет",
        topic: "talk",
        altEn: ["that explains a lot", "it explains a lot"],
        altRu: ["это объяснет многое", "это все объясняет"],
    },
    {
        en: "You know what I mean",
        ru: "Если вы понимаете, о чем я",
        topic: "talk",
        altEn: ["if you know what i mean"],
        altRu: ["если понимаете о чем я",
                "если понимаете о чем я говорю",
                "если вы понимаете что я имею в виду",
                "если понимаете что я имею в виду",
                "если ты понимаешь о чем я",
                "если понимаешь о чем я",
                "если понимаешь о чем я говорю",
                "если ты понимаешь что я имею в виду",
                "если понимаешь что я имею в виду"],
    },
    {
        en: "What do you mean?",
        ru: "Что вы имеете в виду?",
        topic: "talk",
        altEn: [],
        altRu: ["что ты имеешь в виду", "что вы подразумеваете", "что ты подразумеваешь"],
    },
    {
        en: "What do you think…?",
        ru: "Как ты думаешь…?",
        topic: "talk",
        altEn: ["how do you think"],
        altRu: ["как вы думаете", "как вы считаете", 
                "как ты считаешь", "как ты полагаешь",
                "как вы полагаете"],
    },
    {
        en: "What is the point of…?",
        ru: "Какой смысл…?",
        topic: "talk",
        altEn: ["whats the point of", "whats the good of", 
                "what is the good of", "why bother with", 
                "whats the point ", "whats the good",
                "what is the point ", "what is the good"],
        altRu: ["в чем смысл", "в чем польза", "какая польза",
                "в чем польза от", "какая польза от", "какой смысл в"],
    },
    {
        en: "What is your favourite thing about…?",
        ru: "Что вам больше всего нравится в…?",
        topic: "talk",
        altEn: ["what do you enjoy most about", "what do you like most about"],
        altRu: ["что тебе больше всего нравится в",
                "что вы больше всего любите в", "что ты больше всего любишь в",
                "что вам нравится больше всего в", "что тебе нравится больше всего в",
                "что вы любите больше всего в", "что ты любишь больше всего в",
                "за что вам нравится", "за что тебе нравится",
                "за что вы любите", "за что ты любишь"],
    },
    {
        en: "What's with…?",
        ru: "Что с…?",
        topic: "talk",
        altEn: ["what is with", "what is up with", "what gives with",
                "whats up with"],
        altRu: ["что случилось с", "что происходит с", 
                "что произошло с"],
    },
    {
        en: "What's your opinion on…?",
        ru: "Какое у вас мнение насчет…?",
        topic: "talk",
        altEn: ["what is your opinion on"],
        altRu: ["каково ваше мнение насчет", "какое у вас мнение по поводу",
                "каково ваше мнение по поводу", "какое у вас мнение относительно",
                "каково ваше мнение относительно", "какое у вас мнение о",
                "каково ваше мнение о", "какое у тебя мнение насчет",
                "каково твое мнение насчет", "какое у тебя мнение по поводу",
                "каково твое мнение по поводу", "какое у тебя мнение относительно",
                "каково твое мнение относительно", "какое у тебя мнение о",
                "каково твое мнение о"],
    },
    {
        en: "What's the matter?",
        ru: "В чем дело?",
        topic: "talk",
        altEn: ["whats amiss", "whats the matter", 
                "whats the trouble", "whats the problem",
                "what is amiss", "what is the matter", 
                "what is the trouble", "what is the problem"],
        altRu: ["в чем проблема", "что случилось"],
    },
    {
        en: "Where did we leave off?",
        ru: "На чем мы остановились?",
        topic: "talk",
        altEn: ["where were we"],
        altRu: ["где мы остановились"],
    },
    {
        en: "Which one of you…?",
        ru: "Кто из вас…?",
        topic: "talk",
        altEn: ["which of you"],
        altRu: ["кто среди вас"],
    },
    {
        en: "Why do you think that…?",
        ru: "Почему вы думаете, что…?",
        topic: "talk",
        altEn: [],
        altRu: ["почему ты думаешь что",
                "почему ты так думаешь", "почему вы так думаете",
                "с чего ты взял что", "с чего вы взяли что",
                "с чего ты это взял", "с чего вы это взяли"],
    },
    {
        en: "Why don't we…?",
        ru: "Почему бы нам не…?",
        topic: "talk",
        altEn: ["why do not we", "maybe we could", "may be we could"],
        altRu: ["отчего бы нам не", "отчего нам не", "почему нам не",
                "почему бы нам", "отчего бы нам", "отчего нам", "почему нам"],
    },
    {
        en: "Would you happen to know…?",
        ru: "Вы случайно не знаете…?",
        topic: "talk",
        altEn: ["do you happen to know"],
        altRu: ["ты случайно не знаешь"],
    },
    {
        en: "Wow!",
        ru: "Вот это да!",
        topic: "talk",
        altEn: ["sakes alive", "that takes the cake", "shoot",
                "land sakes", "land sakes alive"],
        altRu: ["ух ты", "ничего себе", "вот тебе раз", "вот те раз",
                "вау", "бог ты мой", "надо же", "ого"],
    },
    {
        en: "You got me there!",
        ru: "Тут ты меня подловил!",
        topic: "talk",
        altEn: [],
        altRu: ["тут вы меня подловили", "здесь ты меня подловил",
                "здесь вы меня подловили", "здесь вы подловили меня",
                "тут ты подловил меня", "тут вы подловили меня",
                "тут ты меня подловила", "здесь ты меня подловила",
                "тут ты подловила меня", "тут ты подловила меня"],
    },
    {
        en: "You have got to be kidding",
        ru: "Ты наверное шутишь",
        topic: "talk",
        altEn: ["youve got to be kidding",
                "you have got to be kidding me", "youve got to be kidding me",
                "you must be kidding", "you must be kidding me"],
        altRu: ["ты наверно шутишь",
                "вы наверное шутите", "вы наверно шутите",
                "ты должно быть шутишь", "вы должно быть шутите",
                "это наверное шутка", "это наверно шутка", 
                "это должно быть шутка",
                "ты что шутишь", "вы что шутите"],
    },
    {
        en: "Can you recommend a good cafe nearby?",
        ru: "Можете порекомендовать хорошее кафе неподалеку?",
        topic: "travel",
        altEn: ["сan you recommend a good cafe around here",
                "сan you recommend a good cafe hereabouts",
                "сan you recommend a good cafe hereabout",
                "could you recommend a good cafe nearby",
                "could you recommend a good cafe around here",
                "could you recommend a good cafe hereabouts",
                "could you recommend a good cafe hereabout"],
        altRu: ["не могли бы вы порекомендовать хорошее кафе поблизости",
                "не мог ли ты порекомендовать хорошее кафе неподалеку",
                "не мог ли ты порекомендовать хорошее кафе поблизости",
                "не можете ли вы порекомендовать хорошее кафе неподалеку",
                "не можете ли вы порекомендовать хорошее кафе поблизости",
                "не можешь ты порекомендовать хорошее кафе неподалеку",
                "не можешь ты порекомендовать хорошее кафе поблизости",
                "можете ли вы порекомендовать хорошее кафе неподалеку",
                "можете ли вы порекомендовать хорошее кафе поблизости",
                "можешь ли ты порекомендовать хорошее кафе неподалеку",
                "можешь ли ты порекомендовать хорошее кафе поблизости",
                "вы можете порекомендовать хорошее кафе неподалеку",
                "вы можете порекомендовать хорошее кафе поблизости",
                "ты можешь порекомендовать хорошее кафе неподалеку",
                "ты можешь порекомендовать хорошее кафе поблизости",
                "вы могли бы порекомендовать хорошее кафе неподалеку",
                "вы могли бы порекомендовать хорошее кафе поблизости",
                "ты мог бы порекомендовать хорошее кафе неподалеку",
                "ты мог бы порекомендовать хорошее кафе поблизости",
                "могли бы вы порекомендовать хорошее кафе неподалеку",
                "могли бы вы порекомендовать хорошее кафе поблизости"],
    },
    {
        en: "Follow this road",
        ru: "Двигайтесь по этой дороге",
        topic: "travel",
        altEn: ["follow this road", "take this road", "walk this way",
                "continue down this road", "continue down the road",
                "follow the road", "take the road", "walk the way"],
        altRu: ["идите по этой дороге", "идите этой дорогой",
                "двигайтесь этой дорогой",
                "следуйте этой дорогой", "следуйте по этой дороге",
                "иди по этой дороге", "двигайся по этой дороге",
                "иди этой дорогой", "двигайся этой дорогой",
                "следуй этой дорогой", "следуй по этой дороге"],
    },
    {
        en: "Cross the road",
        ru: "Перейдите дорогу",
        topic: "travel",
        altEn: ["cross the street", "go across the street", "go across the road"],
        altRu: ["перейдите дорогу", 
                "пересеките дорогу", "пересеките улицу",
                "перейдите на другую сторону дороги", "перейдите на другую сторону",
                "перейди через дорогу", "перейди дорогу",
                "пересеки дорогу", "пересеки улицу",
                "перейди на другую сторону дороги", "перейди на другую сторону"],
    },
    {
        en: "Go straight until you reach the bridge",
        ru: "Идите прямо, пока не достигнете моста",
        topic: "travel",
        altEn: ["move forward until you see the bridge",
                "go along until you see the bridge",
                "go ahead until you see the bridge",
                "walk along until you see the bridge",
                "walk straight until you see the bridge",
                "walk ahead until you see the bridge",
                "go straight until you reach a bridge",
                "move forward until you see a bridge",
                "go along until you see a bridge",
                "go ahead until you see a bridge",
                "walk along until you see a bridge",
                "walk straight until you see a bridge",
                "walk ahead until you see a bridge"],
        altRu: ["иди прямо пока не достигнешь мостa",
                "идите прямо до тех пор пока не достигнете моста",
                "иди прямо до тех пор пока не достигнешь мостa",
                "идите прямо пока не дойдете до моста",
                "иди прямо пока не дойдешь до мостa",
                "идите прямо до тех пор пока не дойдете до моста",
                "иди прямо до тех пор пока не дойдешь до мостa",
                "идите прямо пока не выйдете к мосту",
                "иди прямо пока не выйдешь к мосту",
                "идите прямо до тех пор пока не выйдете к мосту",
                "иди прямо до тех пор пока не выйдешь к мосту",
                "идите прямо пока не придете к мосту",
                "иди прямо пока не придешь к мосту",
                "идите прямо до тех пор пока не придете к мосту",
                "иди прямо до тех пор пока не придешь к мосту",
                "идите прямо пока не окажетесь у моста",
                "иди прямо пока не окажешься у моста",
                "идите прямо до тех пор пока не окажетесь у моста",
                "иди прямо до тех пор пока не окажешься у моста",
                "идите прямо пока не доберетесь до моста",
                "иди прямо пока не доберешься до моста",
                "идите прямо до тех пор пока не доберетесь до моста",
                "иди прямо до тех пор пока не доберешься до моста"],
    },
    {
        en: "How do I access to the Internet?",
        ru: "Как мне получить доступ к интернету?",
        topic: "travel",
        altEn: ["how can i access to the internet",
                "how could i acess to the internet",
                "how do i access the internet",
                "how can i access the internet",
                "how could i acess the internet",
                "how do i get access to the internet",
                "how can i get access to the internet",
                "how could i get acess to the internet"],
        altRu: ["как мне подключиться к интернету",
                "как мне получить доступ в интернет",
                "как я могу получить доступ к интернету",
                "как я могу получить доступ в интернет",
                "как я могу подключиться к интернету",
                "как я мог бы получить доступ к интернету",
                "как я мог бы получить доступ в интернет",
                "как я мог бы подключиться к интернету",
                "как мне можно подключиться к интернету",
                "как мне можно получить доступ в интернет"],
    },
    {
        en: "How do I get to…?",
        ru: "Как мне добраться до…?",
        topic: "travel",
        altEn: ["how can i get to", "how do i get to", "how do you get to"],
        altRu: ["как добраться до", "как я могу добраться до",
                "как я мог бы добраться до","как можно добраться до",
                "как мне попасть в", "как я могу попасть в",
                "как попасть в", "как можно попасть в", 
                "как я мог бы попасть в"],
    },
    {
        en: "How far is it to…?",
        ru: "Как далеко до…?",
        topic: "travel",
        altEn: ["how far is to"],
        altRu: ["как далеко", "насколько далеко",
                "насколько далеко до", "далеко ли до", "далеко ли"],
    },
    {
        en: "How much does it cost?",
        ru: "Сколько это стоит?",
        topic: "travel",
        altEn: ["how much is it", "how much is that",
                "how muchs it", "how muchs that", "how much does that cost"],
        altRu: ["по какой это цене", "за сколько это продается"],
    },
    {
        en: "I would like to book…",
        ru: "Я хотел бы забронировать…",
        topic: "travel",
        altEn: ["id like to book"],
        altRu: ["я хочу забронировать", "я хотела бы забронировать"],
    },
    {
        en: "I would like to order…",
        ru: "Я хотел бы заказать…",
        topic: "travel",
        altEn: ["id like to order"],
        altRu: ["я хочу заказать", "я хотела бы заказать"],
    },
    {
        en: "I'm looking for…",
        ru: "Я ищу…",
        topic: "travel",
        altEn: ["i am looking for"],
        altRu: ["я в поисках", "я пытаюсь найти"],
    },
    {
        en: "Is there a place to charge a phone here?",
        ru: "Есть ли здесь место, где можно зарядить телефон?",
        topic: "travel",
        altEn: ["is there a place to charge a phone here",
                "is there a place where you can charge a phone here",
                "is there a place where you can charge your phone here",
                "is there a place you can charge a phone here",
                "is there a place you can charge your phone here",
                "is there a place where i can charge a phone here",
                "is there a place where i can charge my phone here",
                "is there a place i can charge a phone here",
                "is there a place i can charge my phone here",
                "is there a place where it is possible to charge a phone here",
                "is there a place where its possible to charge a phone here"],
        altRu: ["есть ли здесь место для зарядки телефона",
                "есть ли здесь место для зарядки телефонов",
                "есть ли здесь место где можно зарядить телефон",
                "есть ли здесь место где можно заряжать телефон",
                "есть ли здесь место где можно поставить телефон на зарядку",
                "есть ли здесь место где можно поставить телефон на зарядку",
                "есть ли здесь место чтобы зарядить телефон",
                "есть ли здесь место чтобы зарядить телефон",
                "есть ли здесь место чтобы заряжать телефон",
                "есть ли здесь место чтобы поставить телефон на зарядку",
                "есть ли здесь место чтобы поставить телефон на зарядку",
                "есть ли здесь место где я могу зарядить телефон",
                "есть ли здесь место где я могу заряжать телефон",
                "есть ли здесь место где я могу поставить телефон на зарядку",
                "есть ли здесь место где я могу поставить телефон на зарядку",
                "есть ли здесь место где я мог бы зарядить телефон",
                "есть ли здесь место где я мог бы заряжать телефон",
                "есть ли здесь место где я мог бы поставить телефон на зарядку",
                "есть ли здесь место где я мог бы поставить телефон на зарядку",
                "здесь есть место для зарядки телефона",
                "здесь есть место для зарядки телефонов",
                "здесь есть место где можно зарядить телефон",
                "здесь есть место где можно заряжать телефон",
                "здесь есть место где можно поставить телефон на зарядку",
                "здесь есть место где можно поставить телефон на зарядку",
                "здесь есть место чтобы зарядить телефон",
                "здесь есть место чтобы зарядить телефон",
                "здесь есть место чтобы заряжать телефон",
                "здесь есть место чтобы поставить телефон на зарядку",
                "здесь есть место чтобы поставить телефон на зарядку",
                "здесь есть место где я могу зарядить телефон",
                "здесь есть место где я могу заряжать телефон",
                "здесь есть место где я могу поставить телефон на зарядку",
                "здесь есть место где я могу поставить телефон на зарядку",
                "здесь есть место где я мог бы зарядить телефон",
                "здесь есть место где я мог бы заряжать телефон",
                "здесь есть место где я мог бы поставить телефон на зарядку",
                "здесь есть место где я мог бы поставить телефон на зарядку"],
    },
    {
        en: "It's about a five minute walk",
        ru: "Это примерно в пяти минутах ходьбы",
        topic: "travel",
        altEn: ["it is about a five minute walk",
                "it is about five minutes walk",
                "its about five minutes walk",
                "it is about a fiveminute walk",
                "its about a fiveminute walk"],
        altRu: ["это в примерно пяти минутах ходьбы",
                "это примерно пять минут ходьбы",
                "это около пяти минут ходьбы",
                "это примерно в пяти минутах пешком",
                "это в примерно пяти минутах пешком",
                "это примерно пять минут пешком",
                "это около пяти минут пешком"],
    },
    {
        en: "It's about a twenty minute bus ride",
        ru: "Это примерно в двадцати минутах езды на автобусе",
        topic: "travel",
        altEn: ["it is about a twenty minute bus ride",
                "its about a twenty minute bus ride",
                "it is about twenty minutes bus ride",
                "its about twenty minutes bus ride",
                "it is about a twentyminute bus ride",
                "its about a twentyminute bus ride"],
        altRu: ["это в примерно двадцати минутах езды на автобусе",
                "это примерно двадцать минут езды на автобусе",
                "это около двадцати минут езды на автобусе",
                "это примерно в двадцати минутах езды на автобусе",
                "это в примерно двадцати минутах на автобусе",
                "это примерно двадцать минут на автобусе",
                "это около двадцати минут на автобусе",
                "это примерно в двадцати минутах автобусе"],
    },
    {
        en: "It's opposite the hotel",
        ru: "Это напротив отеля",
        topic: "travel",
        altEn: ["it is across from the hotel",
                "it is opposite the hotel",
                "its across from the hotel"],
        altRu: ["это через дорогу от отеля",
                "это напротив гостиницы",
                "это через дорогу от гостиницы"],
    },
    {
        en: "It's next to the supermarket",
        ru: "Это рядом с супермаркетом",
        topic: "travel",
        altEn: ["it is near the supermarket",
                "its near the supermarket",
                "it is next to the supermarket"],
        altRu: ["это за супермаркетом", "это после супермаркета"],
    },
    {
        en: "It's on the other side of the road",
        ru: "Это на другой стороне дороги",
        topic: "travel",
        altEn: ["it is on the other side of the road",
                "its on the other side of the road"],
        altRu: ["это на другой стороне дороги",
                "торговый центр расположен на другой стороне дороги",
                "торговый центр располагается на другой стороне дороги"],
    },
    {
        en: "It's two blocks away",
        ru: "Это в двух кварталах отсюда",
        topic: "travel",
        altEn: ["it is two blocks away"],
        altRu: ["это через два квартала отсюда"],
    },
    {
        en: "May I have the bill?",
        ru: "Могу ли я получить счет?",
        topic: "travel",
        altEn: ["may ive the bill"],
        altRu: ["можно счет", "можно мне счет", 
                "можно мне получить счет",
                "можно мне увидеть счет",
                "могу ли я увидеть счет"],
    },
    {
        en: "Let me off here",
        ru: "Высадите меня здесь",
        topic: "travel",
        altEn: ["let me get off here"],
        altRu: ["высади меня", "высадите меня",
                "выпусти меня", "выпустите меня",
                "высади меня здесь", "высадите меня здесь",
                "выпусти меня здесь", "выпустите меня здесь",
                "высади меня тут", "высадите меня тут",
                "выпусти меня тут", "выпустите меня тут"],
    },
    {
        en: "Take a shortcut through this park",
        ru: "Идите напрямик через этот парк",
        topic: "travel",
        altEn: ["cut off a corner through this park",
                "take a shortcut through the park",
                "cut off a corner through the park",
                "take a short cut through the park",
                "take a short cut through this park"],
        altRu: ["идите прямиком через этот парк",
                "идите напрямую через этот парк",
                "срежьте путь через этот парк",
                "срежьте дорогу через этот парк",
                "иди напрямик через этот парк",
                "иди прямиком через этот парк",
                "иди напрямую через этот парк",
                "срежь путь через этот парк",
                "срежь дорогу через этот парк"],
    },
    {
        en: "Take me to this address",
        ru: "Доставьте меня по этому адресу",
        topic: "travel",
        altEn: ["take me to the address"],
        altRu: ["отвезите меня по этому адресу",
                "отвези меня по этому адресу",
                "доставь меня по этому адресу"],
    },
    {
        en: "Take the second right",
        ru: "Поверните направо на втором перекрёстке",
        topic: "travel",
        altEn: ["turn right on the second crossroads",
                "turn right on the second crossroad",
                "turn right on the second intersection",
                "make the second right turn"],
        altRu: ["на втором перекрестке поверните направо",
                "сверните вправо на втором перекрестке",
                "на втором перекрестке сверните вправо",
                "сверните направо на втором перекрестке",
                "на втором перекрестке сверните направо",
                "поверни направо на втором перекрестке",
                "на втором перекрестке поверни направо",
                "сверни вправо на втором перекрестке",
                "на втором перекрестке сверни вправо",
                "сверни направо на втором перекрестке",
                "на втором перекрестке сверни направо",
                "поверните направо на втором повороте",
                "на втором повороте поверните направо",
                "сверните вправо на втором повороте",
                "на втором повороте сверните вправо",
                "сверните направо на втором повороте",
                "на втором повороте сверните направо",
                "поверни направо на втором повороте",
                "на втором повороте поверни направо",
                "сверни вправо на втором повороте",
                "на втором повороте сверни вправо",
                "сверни направо на втором повороте",
                "на втором повороте сверни направо"],
    },
    {
        en: "Then turn left",
        ru: "Затем поверните налево",
        topic: "travel",
        altEn: ["next turn left", "next take a left turn",
                "next make a left turn",
                "then take a left turn", "then make a left turn"],
        altRu: ["затем поверни налево",
                "затем сверните налево",
                "затем сверни налево"],
    },
    {
        en: "The Pushkin monument stands right in front of this theatre",
        ru: "Памятник Пушкину стоит прямо перед этим театром",
        topic: "travel",
        altEn: ["the pushkin monument is right in front of this theatre",
                "the pushkin monuments right in front of this theatre",
                "the pushkin monument stands right in front of the theatre",
                "the pushkin monument is right in front of the theatre",
                "the pushkin monuments right in front of the theatre",
                "the monument to pushkin is right in front of the theatre",
                "the monument to pushkin stands right in front of this theatre",
                "the monument to pushkin is right in front of this theatre",
                "the monument of pushkin stands right in front of the theatre",
                "the monument for pushkin is right in front of the theatre",
                "the monument for pushkin stands right in front of this theatre",
                "the monument for pushkin is right in front of this theatre",
                "the monument for pushkin stands right in front of the theatre",
                "pushkin monument stands right in front of this theatre",
                "pushkin monument is right in front of this theatre",
                "pushkin monuments right in front of this theatre",
                "pushkin monument stands right in front of the theatre",
                "pushkin monument is right in front of the theatre",
                "pushkin monuments right in front of the theatre"],
        altRu: ["прямо перед этим театром стоит памятник пушкину"],
    },
    {
        en: "The club is around the corner",
        ru: "Клуб находится за углом",
        topic: "travel",
        altEn: ["the clubs around the corner",
                "a clubs around the corner",
                "a club is around the corner",
                "the club is located around the corner", 
                "the clubs located around the corner",
                "a clubs located around the corner",
                "a club is located around the corner",
                "a clubs situated around the corner",
                "a club is situated around the corner"],
        altRu: ["клуб за углом",
                "клуб расположен за углом",
                "клуб располагается за углом",
                "клуб находится за поворотом",
                "клуб за поворотом",
                "клуб расположен за поворотом",
                "клуб располагается за поворотом"],
    },
    {
        en: "The kiosk is on the corner",
        ru: "Киоск находится на углу",
        topic: "travel",
        altEn: ["the kiosks on the corner",
                "the booths on the corner", "the booth is on the corner",
                "the stalls on the corner", "the stall is on the corner",
                "the kiosks located on the corner", "the kiosk is located on the corner",
                "the booths located on the corner", "the booth is located on the corner",
                "the stalls located on the corner", "the stall is located on the corner",
                "the kiosks situated on the corner", "the kiosk is situated on the corner",
                "the booths situated on the corner", "the booth is situated on the corner",
                "the stalls situated on the corner", "the stall is situated on the corner"],
        altRu: ["киоск на углу", 
                "киоск расположен на углу", 
                "киоск располагается на углу",
                "ларек находится на углу", "ларек на углу", 
                "ларек расположен на углу", 
                "ларек располагается на углу"],
    },
    {
        en: "The museum will be on your right",
        ru: "Музей будет справа от вас",
        topic: "travel",
        altEn: ["the museumll be on your right",
                "the museums going to be on your right",
                "the museum is going to be on your right"],
        altRu: ["музей будет находиться справа от вас",
                "музей будет расположен справа от вас",
                "музей будет располагаться справа от вас",
                "музей будет справа от тебя",
                "музей будет находиться справа от тебя",
                "музей будет расположен справа от тебя",
                "музей будет располагаться справа от тебя",
                "музей будет справа",
                "музей будет находиться справа",
                "музей будет расположен справа",
                "музей будет располагаться справа"],
    },
    {
        en: "What is the quickest way to…?",
        ru: "Каков самый быстрый путь до…?",
        topic: "travel",
        altEn: ["whats the quickest way to",
                "whats the shortest way to",
                "what is the shortest way to"],
        altRu: ["какой самый быстрый способ добраться до",
                "какой самый быстрый способ попасть в",
                "каков самый быстрый способ добраться до",
                "каков самый быстрый способ попасть в",
                "как быстрее всего добраться до",
                "как быстрее всего попасть в",
                "какой кратчайший путь до", "каков кратчайший путь до",
                "какой кратчайший путь к", "каков кратчайший путь к",
                "каков кратчайший путь в", "каков кратчайший путь в",
                "какой самый быстрый путь до", "каков самый быстрый путь до",
                "какой самый быстрый путь к", "каков самый быстрый путь к",
                "какой самый быстрый путь в", "каков самый быстрый путь в",
                "какой самый короткий путь до", "каков самый короткий путь до",
                "какой самый короткий путь к", "каков самый короткий путь к",
                "какой самый короткий путь в", "каков самый короткий путь в",
                "какая кратчайшая дорога до", "какова кратчайшая дорога до",
                "какая кратчайшая дорога к", "какова кратчайшая дорога к",
                "какая кратчайшая дорога в", "какова кратчайшая дорога в",
                "какая самая быстрая дорога до", "какова самая быстрая дорога до",
                "какая самая быстрая дорога к", "какова самая быстрая дорога к",
                "какая самая быстрая дорога в", "какова самая быстрая дорога в",
                "какая самая короткая дорога до", "какова самая короткая дорога до",
                "какая самая короткая дорога к", "какова самая короткая дорога к",
                "какая самая короткая дорога в", "какова самая короткая дорога в"],
    },
    {
        en: "Where can I find a grocery store?",
        ru: "Где я могу найти продуктовый магазин?",
        topic: "travel",
        altEn: ["where could i find a grocery store"],
        altRu: ["где я могу найти гастроном",
                "где я могу найти магазин продуктов",
                "где я мог бы найти продуктовый магазин",
                "где бы я мог найти продуктовый магазин",
                "где я мог бы найти магазин продуктов",
                "где бы я мог найти магазин продуктов",
                "где я мог бы найти гастроном",
                "где бы я мог найти гастроном",
                "где я могла бы найти продуктовый магазин",
                "где бы я могла найти продуктовый магазин",
                "где я могла бы найти магазин продуктов",
                "где бы я могла найти магазин продуктов",
                "где я могла бы найти гастроном",
                "где бы я могла найти гастроном"],
    },
    {
        en: "Where is the nearest currency exchange?",
        ru: "Где ближайший обмен валюты?",
        topic: "travel",
        altEn: ["wheres the nearest currency exchange",
                "where is the nearest currency exchange office",
                "wheres the nearest currency exchange office"],
        altRu: ["где находится ближайший обмен валюты",
                "где располагается ближайший обмен валюты",
                "где расположен ближайший обмен валюты",
                "где ближайший пункт обмена валюты",
                "где находится ближайший пункт обмена валюты",
                "где располагается ближайший пункт обмена валюты",
                "где расположен ближайший пункт обмена валюты",
                "где ближайший обменный пункт",
                "где находится ближайший обменный пункт",
                "где располагается ближайший обменный пункт",
                "где расположен ближайший обменный пункт"],
    },
    {
        en: "Where is the restroom?",
        ru: "Где уборная?",
        topic: "travel",
        altEn: ["wheres the restroom", "wheres the toilet", "where is the toilet"],
        altRu: ["где туалет", "где находится туалет",
                "где находится уборная",
                "где располагается туалет", "где располагается уборная",
                "где расположен туалет", "где расположен уборная"],
    },
    {
        en: "Where is the train station located?",
        ru: "Где находится железнодорожный вокзал?",
        topic: "travel",
        altEn: ["where is the train station located",
                "wheres the train station located",
                "where is the train station",
                "wheres the train station",
                "where is the train station sitauted",
                "wheres the train station situated"],
        altRu: ["где находится вокзал",
                "где расположен железнодорожный вокзал",
                "где расположен вокзал",
                "где располагается железнодорожный вокзал",
                "где располагается вокзал"],
    },
    {
        en: "You will pass the bus stop",
        ru: "Вы пройдёте мимо автобусной остановки",
        topic: "travel",
        altEn: ["youll pass the bus stop", 
                "you will go past the bus stop", "youll go past the bus stop"],
        altRu: ["вы пройдете автобусную остановку",
                "ты пройдешь автобусную остановку",
                "ты пройдешь мимо автобусной остановки"],
    },
    {
        en: "You will see traffic lights on the right",
        ru: "Вы увидите светофор справа",
        topic: "travel",
        altEn: ["youll see traffic lights on the right",
                "you will see traffic lights on your right",
                "youll see traffic lights on your right",
                "youll see traffic light on the right",
                "youll see traffic light on the right",
                "you will see traffic light on your right",
                "youll see traffic light on your right"],
        altRu: ["вы увидите светофор справа",
                "справа ты увидишь светофор",
                "ты увидишь светофор справа"],
    },
    {
        en: "A piece of cake",
        ru: "Пара пустяков",
        topic: "idiom",
        altEn: ["piece of cake", "duck soup"],
        altRu: ["проще простого", "легче легкого", "раз плюнуть", "проще пареной репы"],
    },
    {
        en: "A stab in the back",
        ru: "Удар в спину",
        topic: "idiom",
        altEn: ["stab in the back", "a back stab",  "a backstab",
                "back stab", "backstab"],
        altRu: ["нож в спину", "удар ножом в спину"],
    },
    {
        en: "At the drop of a hat",
        ru: "Немедленно и без колебаний",
        topic: "idiom",
        altEn: ["immediately and without hesitation",
                "immediately and unhesitatingly"],
        altRu: ["сразу же", "как заведенный", 
                "незамедлительно", "немедленно", "без колебаний",
                "как по сигналу", "словно по сигналу"],
    },
    {
        en: "Back to the drawing board",
        ru: "Начинаем с чистого листа",
        topic: "idiom",
        altEn: ["start from scratch", "to start from scratch",
                "its back to the drawing board",
                "it is back to the drawing board",
                "back to square one", 
                "go back to the drawing board",
                "lets start from scratch", "let us start from scratch",
                "lets go back to the drawing board", 
                "let us go back to the drawing board"],
        altRu: ["начать с чистого листа", "начинать с чистого листа",
                "вернуться к чистому листу", "начать заново",
                "начинать заново", "начинаем заново",
                "начать все с чистого листа", "начинать все с чистого листа", 
                "начинаем все с чистого листа"],
    },
    {
        en: "Before you know where you are",
        ru: "И ахнуть не успеешь",
        topic: "idiom",
        altEn: ["before you know it", "in a moment"],
        altRu: ["ахнуть не успеешь", "глазом моргнуть не успеешь",
                "в два счета", "в мгновение ока", "в один миг",
                "в одно мгновение", "и глазом моргнуть не успеешь",
                "оглянуться не успеешь", "не успеешь оглянуться",
                "не успеешь глазом моргнуть", "вмиг", "мигом"],
    },
    {
        en: "Break a leg!",
        ru: "Удачи!",
        topic: "idiom",
        altEn: ["good luck"],
        altRu: [],
    },
    {
        en: "By the skin of your teeth",
        ru: "Едва-едва",
        topic: "idiom",
        altEn: ["barely", "by the skin of ones teeth"],
        altRu: ["едва едва", "чудом", "елееле", "еле еле", "едва", "еле",
                "какимто чудом", "каким то чудом"],
    },
    {
        en: "Cat got your tongue?",
        ru: "Язык проглотил?",
        topic: "idiom",
        altEn: ["has the cat got your tongue", "the cat got your tongue"],
        altRu: ["язык проглотили", "язык проглотила",
        "ты что язык проглотил", "ты что язык проглотила",
        "вы что язык проглотили",
        "ты язык проглотил", "ты язык проглотила",
        "вы язык проглотили"],
    },
    {
        en: "Cool as a cucumber",
        ru: "Спокоен как удав",
        topic: "idiom",
        altEn: ["cool calm and collected", "as cool as a cucumber"],
        altRu: ["спокойный как удав", "спокойный как танк",
                "спокоен как танк", "спокойна как удав", "спокойна как удавка", 
                "спокойная как удав", "спокойная как танк",
                "спокойна как танк", "спокойная как удавка"],
    },
    {
        en: "Cross that bridge when you come to it",
        ru: "Решайте проблемы по мере их поступления",
        topic: "idiom",
        altEn: ["cross that bridge when you gets there",
                "cross that bridge when you gets to it",
                "cross your bridges when you come to them",
                "cross a bridge when you gets there",
                "cross a bridge when you gets to it",
                "cross a bridge when you come to it"],
        altRu: ["решай проблемы по мере их поступления",
                "всему свое время"],
    },
    {
        en: "Don't bury your head in the sand!",
        ru: "Не прячьте голову в песок!",
        topic: "idiom",
        altEn: ["dont bury your head in the sand",
                "dont stick your head in the sand",
                "dont hide your head in the sand",
                "dont keep your head in the sand",
                "do not bury your head in the sand",
                "do not stick your head in the sand",
                "do not hide your head in the sand",
                "do not keep your head in the sand"],
        altRu: ["не прячь голову в песок", 
                "не прятайте голову в песок",
                "не прятай голову в песок",
                "не зарывай голову в песок", 
                "не зарывайте голову в песок"],
    },
    {
        en: "From the horse's mouth",
        ru: "Из первых рук",
        topic: "idiom",
        altEn: ["straight from the horses mouth",
                "from the original source",
                "straight from the horse s mouth",
                "from the horse s mouth"],
        altRu: ["из первоисточника", "без посредников",
                "напрямую", "из авторитетного источника",
                "из надежного источника",
                "из авторитетных источников",
                "из надежных источников"],
    },
    {
        en: "Hang in there!",
        ru: "Держитесь там!",
        topic: "idiom",
        altEn: ["hang on in there", "stick it", "hold on there", "hold on"],
        altRu: ["держись там", "держись", "держитесь", 
                "все получится", "не сдавайся", "не сдавайтесь",
                "мужайся", "мужайтесь"],
    },
    {
        en: "He has gone off his rocker",
        ru: "Он съехал с катушек",
        topic: "idiom",
        altEn: ["he is off his rocker", "he is off his nut", 
                "he is off his trolley", "he is off his head", 
                "he is off his chump", "he is off his dot", "he is off his wits",
                "he has gone off his rocker", "he has gone off his nut", 
                "he has gone off his trolley", "he has gone off his head", 
                "he has gone off his chump", "he has gone off his dot", 
                "he has gone off his wits",
                "hes gone off his rocker", "hes gone off his nut", 
                "hes gone off his trolley", "hes gone off his head", 
                "hes gone off his chump", "hes gone off his dot", 
                "hes gone off his wits",
                "he lose his marbles", "he lost his marbles", 
                "heve lost his marbles", "he have lost his marbles", 
                "hes off his rocker", "hes off his nut", 
                "hes off his trolley", "hes off his head", 
                "hes off his chump", "hes off his dot", "hes off his wits",
                "he go crazy", "he went crazy", 
                "he has gone crazy", "hes gone crazy",
                "he go mad", "he went mad", 
                "he has gone mad", "hes gone mad",
                "he go daft", "he went daft", 
                "he has gone daft", "hes gone daft",
                "he get cranky", "he got cranky", 
                "he has got cranky", "hes got cranky",
                "get cranky", "run mad"],
        altRu: ["у него не все дома", "он не в себе", "он сошел с ума",
                "он с приветом", "он рехнулся", "он спятил",
                "он свихнулся", "он чокнулся", "он помешался",
                "он помешанный", "он чокнутый", "он сумасшедший",
                "у него крыша поехала", "у него поехала крыша"],
    },
    {
        en: "In the heat of the moment",
        ru: "В самый разгар",
        topic: "idiom",
        altEn: [],
        altRu: ["в разгар", "в самом разгаре", "в разгаре"],
    },
    {
        en: "In the nick of time",
        ru: "Как раз вовремя",
        topic: "idiom",
        altEn: ["in the very nick of time", "just in time"],
        altRu: ["в последний момент", "в самый последний момент",
                "как раз", "чуть не опоздал", "в критический момент", "в самый момент"],
    },
    {
        en: "It costs a fortune",
        ru: "Это стоит целое состояние",
        topic: "idiom",
        altEn: ["it costs a fortune", "it costs an arm and a leg",
                "it worth a fortune", ],
        altRu: ["это стоит бешеных денег", "это стоит немыслимых денег"],
    },
    {
        en: "It's not my cup of tea",
        ru: "Это не по моей части",
        topic: "idiom",
        altEn: ["it is not my cup of tea",
                "that is not my cup of tea", "thats not my cup of tea",
                "this is not my cup of tea", "thiss not my cup of tea"],
        altRu: ["это не по мне", "это не моя стихия", 
                "это не мое", "это не в моем вкусе", "это не мой тип"],
    },
    {
        en: "Keep your chin up!",
        ru: "Не вешай нос!",
        topic: "idiom",
        altEn: [],
        altRu: ["выше нос", "не вешайте нос", "выше голову",
                "не унывай", "не унывайте", "не вешай голову"],
    },
    {
        en: "Let the dust settle",
        ru: "Пусть пыль осядет",
        topic: "idiom",
        altEn: ["wait for the dust to settle"],
        altRu: ["пускай муть осядет", "пусть муть осядет", 
                "пусть муть рассеется", "пускай муть рассеется",
                "пусть пыль осядет", "пускай пыль осядет"],
    },
    {
        en: "Like a bolt from the blue",
        ru: "Как снег на голову",
        topic: "idiom",
        altEn: ["like a bolt out of the blue", "out of the blue",
                "out of a clear sky", "out of a clear blue sky",
                "a bolt out of the blue"],
        altRu: ["как гром среди ясного неба", "ни с того ни с сего",
                "совершенно неожиданно", "словно снег на голову",
                "будто снег на голову", "будто гром среди ясного неба",
                "словно гром среди ясного неба"],
    },
    {
        en: "Like a fish out of water",
        ru: "Не в своей тарелке",
        topic: "idiom",
        altEn: ["square peg in a round hole", 
                "a square peg in a round hole",
                "a fish out of water", "fish out of water",
                "in the wrong box"],
        altRu: ["не в своей стихии", "как рыба вынутая из воды",
                "не на своем месте"],
    },
    {
        en: "Nip it in the bud",
        ru: "Пресекай это в зародыше",
        topic: "idiom",
        altEn: ["nip that in the bud"],
        altRu: ["пресекайте это в зародыше",
                "пресеки это в зародыше", "пресеките это в зародыше",
                "пресекайте это в корне", "пресекайте это в корне",
                "пресеки это в корне", "пресеките это в корне",
                "пресекайте это на корню", "пресекайте это на корню",
                "пресеки это на корню", "пресеките это на корню",
                "уничтожайте это в зародыше", "уничтожай это в зародыше",
                "уничтожь это в зародыше", "уничтожьте это в зародыше"],
    },
    {
        en: "Once in a blue moon",
        ru: "Очень редко",
        topic: "idiom",
        altEn: ["hardly ever"],
        altRu: ["крайне редко", "очень редко", "практически никогда",
                "раз в столетие", "один раз в столетие"],
    },
    {
        en: "Over the moon",
        ru: "Вне себя от счастья",
        topic: "idiom",
        altEn: ["on cloud nine", "in seventh heaven", 
                "walking on air", "in good spirits", "in high spirits"],
        altRu: ["не помнит себя от радости", "на седьмом небе",
                "на седьмом небе от счастья"],
    },
    {
        en: "Packed like sardines",
        ru: "Как сельди в бочки",
        topic: "idiom2",
        altEn: ["packed in like sardines",
                "packed together like sardines",
                "crammed like sardines",
                "jammed  like sardines",
                "squashed like sardines"],
        altRu: ["набились как сельди в бочке",
                "набилось как сельдей в бочке",
                "набиты как сельди в бочке",
                "как сельдей в бочке"],
    },
    {
        en: "Plain as day",
        ru: "Ясно как день",
        topic: "idiom2",
        altEn: ["plain as a pikestaff", "as plain as a pikestaff", 
                "as plain as day", "plain as the nose on your face",
                "as plain as the nose on your face"],
        altRu: ["ясно как божий день", "яснее ясного", "и дураку ясно",
                "и ребенку ясно", "и слепому видно", "очевидно"],
    },
    {
        en: "Pull yourself together!",
        ru: "Возьми себя в руки!",
        topic: "idiom2",
        altEn: [],
        altRu: ["возьмите себя в руки", "соберись", "соберитесь",
                "овладей собой", "овладейте собой", "сдержите себя",
                "сдержи себя"],
    },
    {
        en: "Speak of the devil!",
        ru: "Только что тебя вспоминали!",
        topic: "idiom2",
        altEn: ["speak of the devil", "talk of the devil",
                "speak of the devil and in he walks",
                "talk of the devil and he is sure to appear",
                "speak of the devil and he is sure to appear",
                "talk of the devil and in he walks"],
        altRu: ["только что тебя вспоминали",
                "только что вас вспоминали", "только что о тебе вспоминали",
                "только что о вас вспоминали", "только что о тебе вспоминали",
                "как раз тебя вспоминали", "как раз вас вспоминали",
                "как раз о тебе вспоминали", "как раз о вас вспоминали",
                "только что о вас говорили", "только что о тебе говорили",
                "как раз о вас говорили", "как раз о тебе говорили",
                "как раз о вас говорим", "как раз о тебе говорим",
                "как раз тебя вспоминаем", "как раз вас вспоминаем",
                "как раз о тебе вспоминаем", "как раз о вас вспоминаем",
                "помянешь черта он тут как тут", "вспомнишь черта он тут как тут"],
    },
    {
        en: "Take her words with a pinch of salt",
        ru: "Дели её слова надвое",
        topic: "idiom2",
        altEn: ["take her words with a grain of salt"],
        altRu: ["дели ее слова напополам", "дели ее слова на два",
                "не доверяй ее словам", 
                "относись к ее словам скептически",
                "относись к ее словам с недоверием",
                "делите ее слова надвое", 
                "делите ее слова напополам", "делите ее слова на два",
                "не доверяйте ее словам", 
                "относитесь к ее словам скептически",
                "относитесь к ее словам с недоверием"],
    },
    {
        en: "That's the last straw!",
        ru: "Это последняя капля!",
        topic: "idiom2",
        altEn: ["thats the last straw", "that is the last straw",
                "thiss the last straw", "this is the last straw",
                "its the last straw", "it is the last straw"],
        altRu: ["это было последней каплей", 
                "это стало последней каплей",
                "это была последняя капля"],
    },
    {
        en: "The best of both worlds",
        ru: "Лучшее из обоих вариантов",
        topic: "idiom2",
        altEn: ["the best of all worlds",
                "the best of all worlds",
                "the best of all possible worlds",
                "best of both worlds", "best of all worlds",
                "best of all worlds",
                "best of all possible worlds"],
        altRu: ["лучшее из обоих миров", "лучшее из двух миров",
                "самое лучшее из обоих вариантов",
                "самое лучшее из обоих миров", 
                "самое лучшее из двух миров"],
    },
    {
        en: "The icing on the cake",
        ru: "Вишенка на торте",
        topic: "idiom2",
        altEn: ["icing on the cake", "frosting on the cake",
                "the icing on the cake", "the frosting on the cake",
                "the cherry on the cake", "cherry on the cake"],
        altRu: [],
    },
    {
        en: "They are like two peas in a pod",
        ru: "Они похожи как две капли воды",
        topic: "idiom2",
        altEn: ["they are alike as two peas in a pod",
                "they are peas from the same pod",
                "theyre like two peas in a pod",
                "theyre alike as two peas in a pod",
                "theyre peas from the same pod"],
        altRu: ["они похожи как две капли", 
                "похожи как две капли воды", "похожи как две капли",
                "они как две капли воды похожи",
                "они как две капли похожи"],
    },
    {
        en: "Through thick and thin",
        ru: "Несмотря на все препятствия",
        topic: "idiom2",
        altEn: ["at any cost",  "at all costs", "at any price",
                "rain or shine", "come rain or shine"],
        altRu: ["при любых обстоятельствах", 
                "во что бы то ни стало",  "несмотря ни на что",
                "несмотря на любые препятствия",
                "несмотря на препятствия",
                "несмотря на все трудности", 
                "несмотря на любые трудности",
                "несмотря на трудности", "любой ценой"],
    },
    {
        en: "To add fuel to the fire",
        ru: "Подлить масла в огонь",
        topic: "idiom2",
        altEn: ["add fuel to the fire", "add fuel to the flame",
                "to add fuel to the flame", "add fuel to the flames",
                "to add fuel to the flames"],
        altRu: ["подлить масло в огонь", "долить масло в огонь",
                "долить масла в огонь", "добавить масло в огонь",
                "доливать масло в огонь", "добавлять масло в огонь",
                "добавить масла в огонь", "доливать масла в огонь",
                "добавлять масла в огонь"],
    },
    {
        en: "To beat around the bush",
        ru: "Ходить вокруг да около",
        topic: "idiom2",
        altEn: ["to beat about the bush", "beat about the bush",
                "beat around the bush"],
        altRu: ["говорить намеками", "говорить обиняками",
                "тянуть рязину", "тянуть кота за хост",
                "не касаться сути", "говорить не касаясь сути"],
    },
    {
        en: "To burn the midnight oil",
        ru: "Засиживаться за работой до ночи",
        topic: "idiom2",
        altEn: ["burn the midnight oil"],
        altRu: ["засиживаться до ночи", 
                "засиживаться до глубокой ночи", 
                "полуночничать",
                "засиживаться за работой до глубокой ночи",
                "работать до ночи", "работать до глубокой ночи"],
    },
    {
        en: "To get out of hand",
        ru: "Выходить из под контроля",
        topic: "idiom2",
        altEn: ["get out of hand", "get out of control",
                "to get out of control"],
        altRu: ["отбиться от рук", "отбиваться от рук",
                "распоясываться", "распоясаться", 
                "выйти из под контроля", "выйти изпод контроля",
                "выходить изпод контроля"],
    },
    {
        en: "To go down in flames",
        ru: "С треском провалиться",
        topic: "idiom2",
        altEn: ["go down in flames",
                "to fail spectacularly", "fail spectacularly",
                "to crash and burn", "crash and burn"],
        altRu: ["провалиться с треском", "потерпеть крах",
                "потерпеть крушение", "потерпеть фиаско",
                "претерпеть крах", "претерпеть крушение",
                "проваливаться с треском", "с треском проваливаться",
                "терпеть крах", "терпеть крушение", "терпеть фиаско"],
    },
    {
        en: "To go with the flow",
        ru: "Плыть по течению",
        topic: "idiom2",
        altEn: ["to go with the tide", "to go with it",
                "go with the tide", "go with the flow", "go with it"],
        altRu: ["плыть по теченью"],
    },
    {
        en: "To hit the nail on the head",
        ru: "Попасть в точку",
        topic: "idiom2",
        altEn: ["to hit the nail on the head", "to hit the nail right on the head",
                "to hit the mark", "to hit the bullseye", "to hit the bulls eye",
                "hit the nail on the head", "hit the nail right on the head",
                "hit the mark", "hit the bullseye", "hit the bulls eye"],
        altRu: ["попасть в яблочко", "попасть в самое яблочко",
                "попасть в самую точку", "попасть в цель",
                "попасть прямо в цель", "попасть в десятку",
                "в яблочко", "в точку", "прямо в цель", 
                "не в бровь а в глаз", "в самое яблочко",
                "в самую точку"],
    },
    {
        en: "To kill two birds with one stone",
        ru: "Убить двух зайцев сразу",
        topic: "idiom2",
        altEn: ["kill two birds with one stone"],
        altRu: ["убить двух зайцев одним выстрелом",
                "убить двух зайцев одним ударом", 
                "убить двух зайцев", "убить двух зайцев одновременно",
                "одним выстрелом убить двух зайцев ",
                "одним ударом убить двух зайцев"],
    },
    {
        en: "To let it ride",
        ru: "Пустить это на самотёк",
        topic: "idiom2",
        altEn: ["to let it go", "let it ride", "let it go"],
        altRu: ["пустить на самотек", "отпустить на самотек",
                "отпустить это на самотек"],
    },
    {
        en: "To make ends meet",
        ru: "Сводить концы с концами",
        topic: "idiom2",
        altEn: ["make ends meet", "make both ends meet",
                "to make both ends meet"],
        altRu: ["свести концы с концами"],
    },
    {
        en: "To miss the boat",
        ru: "Упустить шанс",
        topic: "idiom2",
        altEn: ["to miss the bus", "miss the boat", "miss the bus",
                "miss a chance", "miss the chance", "lose the chance"],
        altRu: ["упускать шанс"],
    },
    {
        en: "To ring hollow",
        ru: "Звучать фальшиво",
        topic: "idiom2",
        altEn: ["to sound hollow", "to ring false",
                "ring hollow", "sound hollow", "ring false"],
        altRu: ["звучать неискренне", "звучать неискренно", "звучать притворно"],
    },
    {
        en: "To see eye to eye",
        ru: "Сходиться во взглядах",
        topic: "idiom2",
        altEn: ["see eye to eye"],
        altRu: ["сходиться во мнениях", "полностью соглашаться", "соглашаться"],
    },
    {
        en: "When pigs fly",
        ru: "Когда рак на горе свистнет",
        topic: "idiom2",
        altEn: ["pigs might fly", "pigs may fly"],
        altRu: ["когда рак в поле свистнет", "после дождичка в четверг",
                "на морковкино заговенье", "после морковкина заговенья",
                "когда рак свистнет", "когда рак на горе свистнет",
                "на турецкую пасху", "на русский байрам"],
    },
    {
        en: "You lose your touch",
        ru: "Ты теряешь хватку",
        topic: "idiom2",
        altEn: ["you are losing your touch", "you are losing your grip",
                "youre losing your touch", "youre losing your grip",
                "you lose your grip"],
        altRu: ["ты теряешь сноровку", "у тебя пропадает сноровка",
                "вы теряете сноровку", "у вас пропадает сноровка",
                "вы теряете хватку"],
    },
    {
        en: "A rising tide lifts all boats",
        ru: "Прилив поднимает все лодки",
        topic: "proverb",
        altEn: ["a rising tide raises all boats"],
        altRu: ["прилив поднимет все лодки"],
    },
    {
        en: "A stitch in time saves nine",
        ru: "Один стежок, сделанный вовремя, стоит девяти",
        topic: "proverb",
        altEn: ["one stitch in time saves nine",
                "a stitch in time", 
                "an ounce of prevention is worth a pound of cure"],
        altRu: ["стежок сделанный вовремя стоит девяти"],
    },
    {
        en: "Actions speak louder than words",
        ru: "Поступки говорят больше, чем слова",
        topic: "proverb",
        altEn: [],
        altRu: ["поступки важнее слов", "поступки говорят больше слов",
                "поступки говорят громче слов", "поступки говорят громче чем слова",
                "дела говорят больше чем слова", "дела важнее слов", 
                "дела говорят больше слов", "дела говорят громче слов",
                "дела говорят громче чем слова", "не по словам судят а по делам"],
    },
    {
        en: "All that glitters is not gold",
        ru: "Не всё то золото, что блестит",
        topic: "proverb",
        altEn: ["all that glitters"],
        altRu: ["не всё золото что блестит"],
    },
    {
        en: "Better late than never",
        ru: "Лучше поздно, чем никогда",
        topic: "proverb",
        altEn: [],
        altRu: [],
    },
    {
        en: "Curiosity killed the cat",
        ru: "Любопытство сгубило кошку",
        topic: "proverb",
        altEn: [],
        altRu: ["любопытство убило кошку",
                "любопытному на днях прищемили нос в дверях",
                "любопытной варваре на базаре нос оторвали",
                "любопытной варваре нос оторвали"],
    },
    {
        en: "Don't bite the hand that feeds you",
        ru: "Не пили сук, на котором сидишь",
        topic: "proverb",
        altEn: ["do not bite the hand that feeds you"],
        altRu: ["не кусай руку которая тебя кормит", "не кусай руку что тебя кормит",
                "не пилите сук на котором сидите",
                "не кусайте руку которая вас кормит", "не кусайте руку что вас кормит",
                "не руби сук на котором сидишь", "не рубите сук на котором сидите"],
    },
    {
        en: "Don't count your chickens before they hatch",
        ru: "Цыплят по осени считают",
        topic: "proverb",
        altEn: ["do not count your chickens before they hatch",
                "do not count your chickens before they are hatched",
                "do not count your chickens before the eggs have hatched",
                "dont count your chickens before they are hatched",
                "dont count your chickens before the eggs have hatched",
                "dont count your chickens before theyre hatched",
                "dont count your chickens before the eggsve hatched",
                "do not count your chickens before theyre hatched",
                "do not count your chickens before the eggsve hatched"],
        altRu: ["не дели шкуру неубитого медведя",
                "не делите шкуру неубитого медведя",
                "не говори гоп пока не перепрыгнешь",
                "не говорите гоп пока не перепрыгнете"],
    },
    {
        en: "Don't judge a book by its cover",
        ru: "Не суди книгу по обложке",
        topic: "proverb",
        altEn: ["do not judge a book by its cover"],
        altRu: ["не суди о книге по обложке",
                "не судите книгу по обложке",
                "не судите о книге по обложке",
                "не суди книгу по ее обложке",
                "не суди о книге по ее обложке",
                "не судите книгу по ее обложке",
                "не судите о книге по ее обложке"],
    },
    {
        en: "Don't put all your eggs in one basket",
        ru: "Не клади все яйца в одну корзину",
        topic: "proverb",
        altEn: ["do not put all your eggs in one basket",
                "do not put all eggs in one basket",
                "dont put all eggs in one basket"],
        altRu: ["не кладите все яйца в одну корзину",
                "не клади яйца в одну корзину",
                "не кладите яйца в одну корзину",
                "не храни все яйца в одной корзине",
                "не храните все яйца в одной корзине"],
    },
    {
        en: "Easier said than done",
        ru: "Проще сказать, чем сделать",
        topic: "proverb",
        altEn: ["more easily said than done", "better said than done",
                "sooner said than done"],
        altRu: ["легче сказать чем сделать"],
    },
    {
        en: "Every cloud has a silver lining",
        ru: "Нет худа без добра",
        topic: "proverb",
        altEn: ["a blessing in disguise", "blessing in disguise"],
        altRu: ["во всем есть положительные стороны",
                "во всем есть положительные моменты",
                "всегда можно найти положительные стороны",
                "всегда можно найти положительные моменты",
                "во всем можно найти положительные стороны",
                "во всем можно найти положительные моменты"],
    },
    {
        en: "Every dog has his day",
        ru: "Будет и на нашей улице праздник",
        topic: "proverb",
        altEn: ["every dog has its day",
                "every dog must have his day",
                "every dog must have its day"],
        altRu: ["будет и на твоей улице праздник",
                "будет и на моей улице праздник",
                "придёт время и мы ногой топнем"],
    },
    {
        en: "Forbidden fruit is the sweetest",
        ru: "Запретный плод сладок",
        topic: "proverb",
        altEn: ["the forbidden fruit is the sweetest",
                "the forbidden fruit tastes the sweetest",
                "forbidden fruit tastes the sweetest",
                "the forbidden fruit is always the sweetest",
                "forbidden fruit is always the sweetest",
                "the forbidden fruits the sweetest",
                "the forbidden fruits the sweetest",
                "the forbidden fruits always the sweetest",
                "forbidden fruits always the sweetest"],
        altRu: ["запретный плод самый сладкий",
                "запретный плод всегда самый сладкий",
                "запретный плод всегда сладкий",
                "запретный плод всегда сладок"],
    },
    {
        en: "Let sleeping dogs lie",
        ru: "Не буди лихо, пока оно тихо",
        topic: "proverb",
        altEn: ["dont trouble trouble until trouble troubles you",
                "do not trouble trouble until trouble troubles you",
                "dont trouble trouble til trouble troubles you",
                "do not trouble trouble til trouble troubles you"],
        altRu: ["не вороши беды коли беда спит",
                "не ищи беды беда сама тебя сыщет",
                "не ищи беды беда сама тебя найдет",
                "не дразни собаку она и не укусит", 
                "не хлещи кобылы и лягать не станет",
                "нe тревожь беды пока беда сама не потревожит",
                "не буди лиха пока спит тихо", 
                "не буди лиха пока лихо спит",
                "не тревожь беду пока беда не потревожит тебя",
                "не тревожь беды пока беда не потревожит тебя"],
    },
    {
        en: "Live and learn!",
        ru: "Век живи, век учись!",
        topic: "proverb",
        altEn: [],
        altRu: [],
    },
    {
        en: "Look before you leap",
        ru: "Думай, прежде чем делать",
        topic: "proverb",
        altEn: ["haste makes waste"],
        altRu: ["думай прежде чем сделать", "семь раз отмерь один отрежь"],
    },
    {
        en: "Make hay while the sun shines",
        ru: "Куй железо, пока горячо",
        topic: "proverb",
        altEn: ["strike while the iron is hot",
                "strike while the irons hot",
                "strike the iron while its hot",
                "strike the iron while it is hot"],
        altRu: ["коси коса пока роса"],
    },
    {
        en: "More haste, less speed",
        ru: "Тише едешь, дальше будешь",
        topic: "proverb",
        altEn: ["longest way round is the shortest way home",
                "low and steady wins the race"],
        altRu: [],
    },
    {
        en: "No guts, no glory",
        ru: "Кто не рискует, тот не пьет шампанское",
        topic: "proverb",
        altEn: ["no risk no reward"],
        altRu: ["волков бояться в лес не ходить",
                "кто не рискует тот не пьет шампанского"],
    },
    {
        en: "No pain, no gain",
        ru: "Без боли нет побед",
        topic: "proverb",
        altEn: [],
        altRu: ["нет боли нет побед", 
                "без труда не вытащишь рыбку из пруда", "без труда не вытащишь и рыбку из пруда",
                "без труда не вытянешь рыбку из пруда", "без труда не вытянешь  и рыбку из пруда",
                "без труда не выловишь рыбку из пруда", "без труда не выловишь  и рыбку из пруда",
                "кто не сеет тот не жнет",
                "терпи казак атаманом будешь"],
    },
    {
        en: "One picture paints a thousand words",
        ru: "Лучше один раз увидеть, чем сто раз услышать",
        topic: "proverb",
        altEn: ["a picture paints a thousand words",
                "a picture is worth a thousand words",
                "a pictures worth a thousand words",
                "one picture is worth a thousand words",
                "one pictures worth a thousand words"],
        altRu: ["лучше один раз увидеть чем семь раз услышать",
                "лучше один раз увидеть чем тысячу раз услышать"],
    },
    {
        en: "Practice makes perfect",
        ru: "Практика ведет к совершенству",
        topic: "proverb",
        altEn: [],
        altRu: ["практика путь к совершенству",
                "практика это путь к совершенству",
                "практика приводит к совершенству",
                "практика творит чудеса",
                "повторение мать учения",
                "практика совершенствует",
                "практика делает совершенным"],
    },
    {
        en: "Rome wasn't built in a day",
        ru: "Москва не сразу строилась",
        topic: "proverb",
        altEn: ["rome was not built in a day", "rome was not built in one day",
                "rome wasnt built in one day"],
        altRu: ["рим был построен не за один день",
                "рим не за один день строился", "рим не в один день строился",
                "рим строился не один день",
                "рим построили не за один день", "рим построили не за день",
                "рим не был построен за один день", "рим не был построен за день",
                "рим не сразу строился",
                "рим не за один день построили",
                "рим не за один день был построен"],
    },
    {
        en: "Still waters run deep",
        ru: "В тихом омуте черти водятся",
        topic: "proverb",
        altEn: ["still water runs deep"],
        altRu: [],
    },
    {
        en: "Tastes differ",
        ru: "О вкусах не спорят",
        topic: "proverb",
        altEn: ["there is no accounting for taste", "there is no accounting for tastes",
                "theres no accounting for taste", "theres no accounting for tastes",
                "opinions differ"],
        altRu: ["на вкус и цвет товарищей нет",
                "на вкус и цвет все фломастеры разные",
                "на вкус и цвет фломастеры разные"],
    },
    {
        en: "The grass is always greener on the other side of the fence",
        ru: "Там хорошо, где нас нет",
        topic: "proverb",
        altEn: ["the grass is always greener",
                "the grass is always greener on the other side"],
        altRu: ["хорошо там где нас нет", 
                "там хорошо где нас с тобой нет", "хорошо там где нас с тобой нет"],
    },
    {
        en: "The pen is mightier than the sword",
        ru: "Перо сильнее меча",
        topic: "proverb",
        altEn: ["the pens mightier than the sword"],
        altRu: ["перо сильнее чем меч", 
                "перо могущественнее чем меч", "перо могущественнее меча", 
                "перо страшнее пистолета"],
    },
    {
        en: "Well begun is half done",
        ru: "Хорошее начало - половина дела",
        topic: "proverb",
        altEn: ["a good beginning makes a good ending"],
        altRu: ["хорошее начало это половина дела", "хорошее начало это уже половина дела",
                "хорошее начало уже половина дела", "хорошее начало полдела", 
                "хорошее уже начало полдела", "хорошее начало это уже полдела"],
    },
    {
        en: "When it rains, it pours",
        ru: "Беда не приходит одна",
        topic: "proverb",
        altEn: ["it never rains but it pours", "it never rains but that it pours",
                "misfortunes never come singly", "misfortunes never come alone"],
        altRu: ["беда одна не ходит", "беда одна не ходит за собой другую водит",
                "пришла беда отворяй ворота", "беда приходит не одна"],
    },
]